// // // ArtisanProfile.jsx - Updated with correct API response handling
// // import React, { useState, useEffect, useRef } from 'react';
// // import { useNavigate } from 'react-router-dom';
// // import FurnitureNavbar from '../../../components/layout/Nav';
// // import './artisanprofile.scss';
// // import withAuth from '../../auth/WithAuth';
// // import defaultAvatar from '../../../assets/DefaultProfile.png';
// // import {
// //   FaUser,
// //   FaEnvelope,
// //   FaPhone,
// //   FaCamera,
// //   FaCheck,
// //   FaExclamationTriangle,
// //   FaEdit,
// //   FaTimes,
// //   FaImage,
// //   FaStar,
// //   FaAward,
// //   FaPlus,
// //   FaTrash,
// //   FaArrowRight,
// //   FaCrop,
// //   FaTimesCircle,
// //   FaInfoCircle,
// //   FaLocationArrow,
// //   FaWallet,
// //   FaMobileAlt,
// //   FaUniversity,
// //   FaLock,
// //   FaEye,
// //   FaEyeSlash,
// // } from 'react-icons/fa';
// // import Button from 'react-bootstrap/Button';
// // import Form from 'react-bootstrap/Form';
// // import Alert from 'react-bootstrap/Alert';
// // import Carousel from 'react-bootstrap/Carousel';
// // import Modal from 'react-bootstrap/Modal';
// // import { serverUrlAuth } from '../../../serverUrl';
// // import { toast } from 'react-toastify';
// // import ReactCrop from 'react-image-crop';
// // import 'react-image-crop/dist/ReactCrop.css';

// // const ArtisanProfile = () => {
// //   const navigate = useNavigate();
// //   const [activeTab, setActiveTab] = useState('profile');
// //   const [profile, setProfile] = useState({
// //     name: '',
// //     email: '',
// //     phone: '',
// //     avatar: defaultAvatar,
// //     location: '',
// //     experience_years: 0,
// //     rating: 0,
// //     completed_projects: 0,
// //   });
// //   const [editable, setEditable] = useState(false);
// //   const [alerts, setAlerts] = useState({
// //     profile: '',
// //     legacy: '',
// //     portfolio: '',
// //     payment: '',
// //   });
// //   const [isLoading, setIsLoading] = useState(false);

// //   // Portfolio & legacy project state
// //   const [portfolioData, setPortfolioData] = useState(null);
// //   const [portfolio, setPortfolio] = useState([]);
// //   const [artisanProfile, setArtisanProfile] = useState([]);
// //   const [legacyForm, setLegacyForm] = useState({
// //     title: '',
// //     description: '',
// //     rating: 1,
// //     images: [],
// //   });
// //   const fileInputRef = useRef(null);

// //   // Payment Details State
// //   const [paymentDetails, setPaymentDetails] = useState({
// //     payment_method: '',
// //     mpesa_phone_number: '',
// //     mpesa_name: '',
// //     bank_name: '',
// //     bank_account_name: '',
// //     bank_account_number: '',
// //     bank_branch: '',
// //   });
// //   const [paymentViewPassword, setPaymentViewPassword] = useState('');
// //   const [showPaymentPassword, setShowPaymentPassword] = useState(false);
// //   const [isPaymentVerified, setIsPaymentVerified] = useState(false);
// //   const [isPaymentLoading, setIsPaymentLoading] = useState(false);
// //   const [paymentEditable, setPaymentEditable] = useState(false);
// //   const [paymentErrors, setPaymentErrors] = useState({});
// //   const [isVerifying, setIsVerifying] = useState(false);

// //   // Crop state
// //   const [showCropModal, setShowCropModal] = useState(false);
// //   const [selectedImage, setSelectedImage] = useState(null);
// //   const [crop, setCrop] = useState({
// //     unit: '%',
// //     width: 80,
// //     height: 80,
// //     x: 10,
// //     y: 10,
// //   });
// //   const [completedCrop, setCompletedCrop] = useState(null);
// //   const [croppedImageUrl, setCroppedImageUrl] = useState(null);
// //   const [croppedImageFile, setCroppedImageFile] = useState(null);
// //   const imgRef = useRef(null);

// //   const fetchProfile = async () => {
// //     try {
// //       const res = await serverUrlAuth.get('users/profile/');
// //       const data = res.data;
// //       setProfile((prev) => ({
// //         ...prev,
// //         name: data.full_name,
// //         email: data.email,
// //         phone: data.phone_number || '',
// //         avatar: data.profile_picture || defaultAvatar,
// //       }));
// //     } catch (error) {
// //       console.error('Failed to fetch profile:', error);
// //     }
// //   };

// //   const fetchArtisanProfile = async () => {
// //     try {
// //       const response = await serverUrlAuth.get('users/artisan/profile/');
// //       setArtisanProfile(response.data);

// //       // Set basic profile info from artisan profile
// //       if (response.data) {
// //         setProfile((prev) => ({
// //           ...prev,
// //           location: response.data.location || '',
// //         }));
// //       }
// //     } catch (error) {
// //       console.error('Failed to fetch artisan profile:', error);
// //     }
// //   };

// //   // Fetch user profile
// //   useEffect(() => {
// //     fetchProfile();
// //     fetchArtisanProfile();
// //   }, []);

// //   // Fetch portfolio and stats
// //   const loadPortfolio = async () => {
// //     try {
// //       const res = await serverUrlAuth.get('portfolio/artisan-portfolio/');
// //       const data = res.data;
// //       setPortfolioData(data);
// //       setPortfolio(data.portfolio_items || []);
// //       setProfile((prev) => ({
// //         ...prev,
// //         experience_years: data.years_of_experience || 0,
// //         rating: data.client_rating || 0,
// //         completed_projects: data.projects_completed || 0,
// //       }));
// //     } catch (error) {
// //       console.error('Failed to load portfolio:', error);
// //       showAlert('portfolio', 'Failed to load portfolio', 'error');
// //     }
// //   };

// //   useEffect(() => {
// //     loadPortfolio();
// //   }, []);

// //   const showAlert = (type, message, variant = 'success') => {
// //     setAlerts((prev) => ({ ...prev, [type]: { message, variant } }));
// //     setTimeout(() => setAlerts((prev) => ({ ...prev, [type]: '' })), 5000);
// //   };

// //   const handleProfileChange = (e) => {
// //     const { name, value } = e.target;
// //     setProfile((prev) => ({ ...prev, [name]: value }));
// //   };

// //   // Handle avatar selection with crop
// //   const handleAvatarChange = (e) => {
// //     const file = e.target.files[0];
// //     if (file) {
// //       if (!file.type.startsWith('image/')) {
// //         showAlert('profile', 'Please select a valid image', 'error');
// //         return;
// //       }
// //       if (file.size > 5 * 1024 * 1024) {
// //         showAlert('profile', 'Image must be less than 5MB', 'error');
// //         return;
// //       }

// //       const reader = new FileReader();
// //       reader.onload = () => {
// //         setSelectedImage(reader.result);
// //         setShowCropModal(true);
// //         setCrop({
// //           unit: '%',
// //           width: 80,
// //           height: 80,
// //           x: 10,
// //           y: 10,
// //         });
// //         setCompletedCrop(null);
// //         setCroppedImageUrl(null);
// //         setCroppedImageFile(null);
// //       };
// //       reader.readAsDataURL(file);
// //       e.target.value = null;
// //     }
// //   };

// //   const triggerFileInput = () => editable && fileInputRef.current?.click();

// //   // Handle crop completion
// //   const onCropComplete = (crop) => {
// //     setCompletedCrop(crop);
// //   };

// //   // Generate cropped image
// //   const getCroppedImg = async () => {
// //     if (!imgRef.current || !completedCrop) {
// //       return;
// //     }

// //     try {
// //       const canvas = document.createElement('canvas');
// //       const image = imgRef.current;
// //       const crop = completedCrop;

// //       const scaleX = image.naturalWidth / image.width;
// //       const scaleY = image.naturalHeight / image.height;

// //       canvas.width = crop.width * scaleX;
// //       canvas.height = crop.height * scaleY;

// //       const ctx = canvas.getContext('2d');

// //       ctx.imageSmoothingEnabled = true;
// //       ctx.imageSmoothingQuality = 'high';

// //       ctx.drawImage(
// //         image,
// //         crop.x * scaleX,
// //         crop.y * scaleY,
// //         crop.width * scaleX,
// //         crop.height * scaleY,
// //         0,
// //         0,
// //         crop.width * scaleX,
// //         crop.height * scaleY,
// //       );

// //       return new Promise((resolve) => {
// //         canvas.toBlob(
// //           (blob) => {
// //             if (blob) {
// //               const url = URL.createObjectURL(blob);
// //               const file = new File([blob], 'avatar.jpg', {
// //                 type: 'image/jpeg',
// //               });
// //               resolve({ url, file });
// //             }
// //           },
// //           'image/jpeg',
// //           0.95,
// //         );
// //       });
// //     } catch (error) {
// //       console.error('Error cropping image:', error);
// //       showAlert('profile', 'Failed to crop image', 'error');
// //     }
// //   };

// //   // Apply crop and close modal
// //   const applyCrop = async () => {
// //     if (!completedCrop) {
// //       showAlert('profile', 'Please crop the image first', 'error');
// //       return;
// //     }

// //     try {
// //       const result = await getCroppedImg();
// //       if (result) {
// //         setCroppedImageUrl(result.url);
// //         setCroppedImageFile(result.file);
// //         setProfile((prev) => ({ ...prev, avatar: result.url }));
// //         showAlert('profile', 'Avatar cropped successfully!', 'success');
// //         setShowCropModal(false);
// //       }
// //     } catch (error) {
// //       console.error('Error applying crop:', error);
// //       showAlert('profile', 'Failed to apply crop', 'error');
// //     }
// //   };

// //   // Cancel crop modal
// //   const cancelCrop = () => {
// //     setShowCropModal(false);
// //     setSelectedImage(null);
// //     setCroppedImageUrl(null);
// //     setCroppedImageFile(null);
// //     setCompletedCrop(null);
// //   };

// //   const toggleEdit = () => setEditable(true);
// //   const cancelEdit = () => {
// //     setEditable(false);
// //     setCroppedImageUrl(null);
// //     setCroppedImageFile(null);
// //   };

// //   const saveProfile = async (e) => {
// //     e.preventDefault();
// //     setIsLoading(true);
// //     try {
// //       const formData = new FormData();
// //       formData.append('full_name', profile.name);
// //       formData.append('phone_number', profile.phone);
// //       formData.append('location', profile.location);

// //       // Use cropped image if available
// //       if (croppedImageFile) {
// //         formData.append('profile_picture', croppedImageFile);
// //       } else if (fileInputRef.current?.files[0]) {
// //         formData.append('profile_picture', fileInputRef.current.files[0]);
// //       }

// //       const res = await serverUrlAuth.patch('users/profile/', formData, {
// //         headers: { 'Content-Type': 'multipart/form-data' },
// //       });

// //       setProfile((prev) => ({
// //         ...prev,
// //         avatar: res.data.profile_picture || prev.avatar,
// //       }));
// //       setCroppedImageUrl(null);
// //       setCroppedImageFile(null);
// //       showAlert('profile', 'Profile updated successfully!', 'success');
// //       setEditable(false);
// //     } catch (error) {
// //       console.error(error);
// //       showAlert('profile', 'Failed to update profile', 'error');
// //     } finally {
// //       setIsLoading(false);
// //     }
// //   };

// //   // Cleanup object URLs on unmount
// //   useEffect(() => {
// //     return () => {
// //       if (croppedImageUrl) {
// //         URL.revokeObjectURL(croppedImageUrl);
// //       }
// //     };
// //   }, [croppedImageUrl]);

// //   // --- LEGACY PROJECT HANDLERS ---
// //   const handleLegacyChange = (e) => {
// //     const { name, value, files } = e.target;
// //     if (name === 'images') {
// //       setLegacyForm((prev) => ({ ...prev, images: files }));
// //     } else {
// //       setLegacyForm((prev) => ({ ...prev, [name]: value }));
// //     }
// //   };

// //   const saveLegacyProject = async (e) => {
// //     e.preventDefault();
// //     setIsLoading(true);

// //     try {
// //       const formData = new FormData();
// //       formData.append('title', legacyForm.title);
// //       formData.append('description', legacyForm.description);
// //       formData.append('rating', legacyForm.rating);

// //       for (let i = 0; i < legacyForm.images.length; i++) {
// //         formData.append('images', legacyForm.images[i]);
// //       }

// //       const response = await serverUrlAuth.post(
// //         'portfolio/artisan-portfolio/legacy/create/',
// //         formData,
// //       );

// //       toast.success(
// //         response.data.detail || 'Legacy project added successfully!',
// //       );
// //       setLegacyForm({ title: '', description: '', rating: 1, images: [] });

// //       // Refresh portfolio
// //       await loadPortfolio();

// //       // Show remaining slots
// //       if (response.data.remaining_slots > 0) {
// //         toast.info(
// //           `You have ${response.data.remaining_slots} more legacy project slots remaining.`,
// //         );
// //       } else {
// //         toast.info('You have reached the maximum of 5 legacy projects.');
// //       }
// //     } catch (err) {
// //       console.error(err);
// //       const msg =
// //         err.response?.data?.detail ||
// //         'Failed to add legacy project. Maybe you reached the 5-project limit.';
// //       showAlert('legacy', msg, 'error');
// //     } finally {
// //       setIsLoading(false);
// //     }
// //   };

// //   // --- PAYMENT DETAILS HANDLERS ---

// //   // Verify password to view payment details
// //   const verifyPaymentPassword = async (e) => {
// //     e.preventDefault();

// //     if (!paymentViewPassword) {
// //       toast.error('Please enter your password');
// //       return;
// //     }

// //     setIsVerifying(true);
// //     try {
// //       const response = await serverUrlAuth.post(
// //         'users/payment-details/verify/',
// //         { password: paymentViewPassword }
// //       );

// //       if (response.data.status) {
// //         setIsPaymentVerified(true);

// //         // Set payment details based on the response
// //         const details = response.data.payment_details;
// //         setPaymentDetails({
// //           payment_method: details.payment_method || 'mpesa',
// //           mpesa_phone_number: details.mpesa_phone_number || '',
// //           mpesa_name: details.mpesa_name || '',
// //           bank_name: details.bank_name || '',
// //           bank_account_name: details.bank_account_name || '',
// //           bank_account_number: details.bank_account_number || '',
// //           bank_branch: details.bank_branch || '',
// //         });

// //         toast.success(response.data.message || 'Password verified successfully!');
// //         setPaymentViewPassword('');
// //         setPaymentErrors({});
// //       }
// //     } catch (error) {
// //       console.error('Password verification failed:', error);
// //       if (error.response?.data) {
// //         toast.error(error.response.data.message || 'Invalid password');
// //         setPaymentErrors({ password: error.response.data.message || 'Invalid password' });
// //       } else {
// //         toast.error('Failed to verify password');
// //       }
// //       setPaymentViewPassword('');
// //     } finally {
// //       setIsVerifying(false);
// //     }
// //   };

// //   // Mask sensitive information for display
// //   const maskPhoneNumber = (phone) => {
// //     if (!phone) return 'Not set';
// //     if (phone.length <= 4) return phone;
// //     const start = phone.slice(0, 4);
// //     const end = phone.slice(-2);
// //     return `${start}******${end}`;
// //   };

// //   const maskAccountNumber = (account) => {
// //     if (!account) return 'Not set';
// //     if (account.length <= 4) return account;
// //     const start = account.slice(0, 4);
// //     return `${start}******`;
// //   };

// //   const maskAccountName = (name) => {
// //     if (!name) return 'Not set';
// //     if (name.length <= 3) return name;
// //     const start = name.slice(0, 3);
// //     const remaining = name.slice(3).replace(/./g, '*');
// //     return start + remaining;
// //   };

// //   const maskBankName = (name) => {
// //     if (!name) return 'Not set';
// //     if (name.length <= 3) return name;
// //     const start = name.slice(0, 3);
// //     const remaining = name.slice(3).replace(/./g, '*');
// //     return start + remaining;
// //   };

// //   // Enable edit mode
// //   const enablePaymentEdit = () => {
// //     setPaymentEditable(true);
// //     setPaymentErrors({});
// //   };

// //   // Cancel payment edit
// //   const cancelPaymentEdit = () => {
// //     setPaymentEditable(false);
// //     setPaymentErrors({});
// //     // Reset to verified details - re-verify to get latest data
// //     setIsPaymentVerified(false);
// //     setPaymentViewPassword('');
// //     toast.info('Please re-verify your password to view payment details');
// //   };

// //   // Handle payment input change in edit mode
// //   const handlePaymentInputChange = (e) => {
// //     const { name, value } = e.target;
// //     setPaymentDetails(prev => ({ ...prev, [name]: value }));
// //     if (paymentErrors[name]) {
// //       setPaymentErrors(prev => ({ ...prev, [name]: '' }));
// //     }
// //   };

// //   const handlePaymentMethodChange = (method) => {
// //     setPaymentDetails(prev => ({ ...prev, payment_method: method }));
// //     setPaymentErrors({});
// //   };

// //   // Validate payment details
// //   const validatePaymentDetails = () => {
// //     const errors = {};

// //     if (paymentDetails.payment_method === 'mpesa') {
// //       if (!paymentDetails.mpesa_phone_number) {
// //         errors.mpesa_phone_number = 'Phone number is required';
// //       } else {
// //         const phone = paymentDetails.mpesa_phone_number.replace(/\s/g, '');
// //         const phoneRegex = /^(?:\+254|0)?[17]\d{8}$/;
// //         if (!phoneRegex.test(phone)) {
// //           errors.mpesa_phone_number = 'Please enter a valid Kenyan phone number (e.g., 0712345678)';
// //         }
// //       }
// //     } else if (paymentDetails.payment_method === 'bank') {
// //       if (!paymentDetails.bank_name) {
// //         errors.bank_name = 'Bank name is required';
// //       }
// //       if (!paymentDetails.bank_account_name) {
// //         errors.bank_account_name = 'Account name is required';
// //       }
// //       if (!paymentDetails.bank_account_number) {
// //         errors.bank_account_number = 'Account number is required';
// //       }
// //     }

// //     return errors;
// //   };

// //   // Save payment details
// //   const savePaymentDetails = async (e) => {
// //     e.preventDefault();

// //     const errors = validatePaymentDetails();
// //     if (Object.keys(errors).length > 0) {
// //       setPaymentErrors(errors);
// //       return;
// //     }

// //     setIsPaymentLoading(true);
// //     try {
// //       const payload = {
// //         payment_method: paymentDetails.payment_method,
// //         mpesa_phone_number: paymentDetails.mpesa_phone_number,
// //         bank_name: paymentDetails.bank_name,
// //         bank_account_name: paymentDetails.bank_account_name,
// //         bank_account_number: paymentDetails.bank_account_number,
// //         bank_branch: paymentDetails.bank_branch,
// //       };

// //       const response = await serverUrlAuth.patch('users/artisan/profile/', payload);

// //       toast.success(response.data.message || 'Payment details updated successfully!');
// //       setPaymentEditable(false);
// //       setPaymentErrors({});

// //       // Refresh the payment details by re-verifying
// //       // But we need to re-verify with password to get updated masked data
// //       setIsPaymentVerified(false);
// //       setPaymentViewPassword('');
// //       toast.info('Please re-verify your password to view updated payment details');

// //     } catch (error) {
// //       console.error('Error saving payment details:', error);
// //       if (error.response?.data) {
// //         toast.error(error.response.data.message || 'Failed to save payment details');
// //       } else {
// //         toast.error('Failed to save payment details');
// //       }
// //     } finally {
// //       setIsPaymentLoading(false);
// //     }
// //   };

// //   // Navigate to delete account page
// //   const handleDeleteAccountClick = () => {
// //     navigate('/delete-account');
// //   };

// //   // Get legacy project count and remaining slots
// //   const legacyCount = portfolioData?.legacy_projects_count || 0;
// //   const maxLegacyProjects = 5;
// //   const remainingLegacySlots = Math.max(0, maxLegacyProjects - legacyCount);

// //   return (
// //     <>
// //       <FurnitureNavbar />
// //       <div className="profile-page">
// //         <div className="profile-layout">
// //           <div className="vertical-tabs">
// //             <button
// //               className={`tab-btn ${activeTab === 'profile' ? 'active' : ''}`}
// //               onClick={() => setActiveTab('profile')}
// //             >
// //               <FaUser className="tab-icon" /> Profile Information
// //             </button>

// //             <button
// //               className={`tab-btn ${activeTab === 'payment' ? 'active' : ''}`}
// //               onClick={() => {
// //                 setActiveTab('payment');
// //                 // Reset verification state when switching to payment tab
// //                 setIsPaymentVerified(false);
// //                 setPaymentEditable(false);
// //                 setPaymentViewPassword('');
// //                 setPaymentErrors({});
// //               }}
// //             >
// //               <FaWallet className="tab-icon" /> Payment Details
// //             </button>

// //             {remainingLegacySlots > 0 && (
// //               <button
// //                 className={`tab-btn ${activeTab === 'legacy' ? 'active' : ''}`}
// //                 onClick={() => setActiveTab('legacy')}
// //               >
// //                 <FaPlus className="tab-icon" /> Add Legacy Portfolio
// //                 <span className="tab-badge">{remainingLegacySlots}</span>
// //               </button>
// //             )}

// //             <button
// //               className={`tab-btn ${activeTab === 'portfolio' ? 'active' : ''}`}
// //               onClick={() => setActiveTab('portfolio')}
// //             >
// //               <FaImage className="tab-icon" /> My Portfolio
// //             </button>

// //             {/* Delete Account Tab - Navigates to /delete-account */}
// //             <button
// //               className="tab-btn delete-tab"
// //               onClick={handleDeleteAccountClick}
// //             >
// //               <FaTrash className="tab-icon" /> Delete Account
// //               <FaArrowRight className="tab-arrow" />
// //             </button>
// //           </div>

// //           <div className="profile-content">
// //             {/* Alerts */}
// //             {['profile', 'legacy', 'portfolio', 'payment'].map(
// //               (type) =>
// //                 alerts[type] && (
// //                   <Alert
// //                     key={type}
// //                     variant={alerts[type].variant}
// //                     className="alert-custom"
// //                   >
// //                     {alerts[type].variant === 'success' ? (
// //                       <FaCheck />
// //                     ) : (
// //                       <FaExclamationTriangle />
// //                     )}
// //                     {alerts[type].message}
// //                   </Alert>
// //                 ),
// //             )}

// //             {/* PROFILE TAB */}
// //             {activeTab === 'profile' && (
// //               <div className="profile-card">
// //                 <div className="card-header">
// //                   <h3>Profile Information</h3>
// //                   <p>Update your artisan profile and showcase your expertise</p>
// //                 </div>
// //                 <div className="card-content">
// //                   <div className="avatar-section">
// //                     <div className="avatar-preview">
// //                       <img src={profile.avatar} alt="Profile Avatar" />
// //                     </div>
// //                     {editable && (
// //                       <>
// //                         <Button
// //                           className="change-avatar"
// //                           onClick={triggerFileInput}
// //                         >
// //                           <FaCamera /> Change Profile Photo
// //                         </Button>
// //                         <input
// //                           type="file"
// //                           ref={fileInputRef}
// //                           onChange={handleAvatarChange}
// //                           accept="image/*"
// //                           style={{ display: 'none' }}
// //                         />
// //                       </>
// //                     )}
// //                   </div>
// //                   <div className="info-section">
// //                     <Form onSubmit={saveProfile}>
// //                       <Form.Group className="form-group-custom">
// //                         <Form.Label>
// //                           <FaUser /> Full Name
// //                         </Form.Label>
// //                         <Form.Control
// //                           type="text"
// //                           name="name"
// //                           value={profile.name}
// //                           onChange={handleProfileChange}
// //                           disabled={!editable}
// //                           required
// //                         />
// //                       </Form.Group>
// //                       <Form.Group className="form-group-custom">
// //                         <Form.Label>
// //                           <FaEnvelope /> Email
// //                         </Form.Label>
// //                         <Form.Control
// //                           type="email"
// //                           value={profile.email}
// //                           disabled
// //                         />
// //                       </Form.Group>
// //                       <Form.Group className="form-group-custom">
// //                         <Form.Label>
// //                           <FaPhone /> Phone
// //                         </Form.Label>
// //                         <Form.Control
// //                           type="tel"
// //                           name="phone"
// //                           value={profile.phone}
// //                           onChange={handleProfileChange}
// //                           disabled={!editable}
// //                         />
// //                       </Form.Group>
// //                       <Form.Group className="form-group-custom">
// //                         <Form.Label>
// //                           <FaLocationArrow /> Location
// //                         </Form.Label>
// //                         <Form.Control
// //                           type="text"
// //                           name="location"
// //                           value={artisanProfile.location || ''}
// //                           disabled
// //                         />
// //                       </Form.Group>
// //                       {!editable ? (
// //                         <Button
// //                           className="edit-profile-btn"
// //                           size="sm"
// //                           onClick={toggleEdit}
// //                         >
// //                           <FaEdit /> Edit Profile
// //                         </Button>
// //                       ) : (
// //                         <div className="form-actions">
// //                           <Button
// //                             className="save-changes-btn"
// //                             type="submit"
// //                             disabled={isLoading}
// //                           >
// //                             {isLoading ? 'Saving...' : 'Save Changes'}
// //                           </Button>
// //                           <Button variant="secondary" onClick={cancelEdit}>
// //                             <FaTimes /> Cancel
// //                           </Button>
// //                         </div>
// //                       )}
// //                     </Form>
// //                   </div>
// //                 </div>
// //               </div>
// //             )}

// //             {/* PAYMENT DETAILS TAB */}
// //             {activeTab === 'payment' && (
// //               <div className="profile-card payment-details-card">
// //                 <div className="card-header">
// //                   <h3>
// //                     <FaWallet className="header-icon" /> Payment Details
// //                   </h3>
// //                   <p>Manage how you receive payments for your work</p>
// //                 </div>

// //                 <div className="card-content">
// //                   {!isPaymentVerified ? (
// //                     // Password Verification Screen
// //                     <div className="password-verification-section">
// //                       <div className="verification-icon">
// //                         {/* <FaLock /> */}
// //                       </div>
// //                       <h4>🔒 Protected Information</h4>
// //                       <p>
// //                         Enter your password to view your payment details.
// //                         This ensures the security of your financial information.
// //                       </p>
// //                       <form onSubmit={verifyPaymentPassword} className="verification-form">
// //                         <div className="password-input-group">
// //                           <div className="password-input-wrapper">
// //                             <Form.Control
// //                               type={showPaymentPassword ? 'text' : 'password'}
// //                               placeholder="Enter your password"
// //                               value={paymentViewPassword}
// //                               onChange={(e) => {
// //                                 setPaymentViewPassword(e.target.value);
// //                                 setPaymentErrors({});
// //                               }}
// //                               className={`password-input ${paymentErrors.password ? 'error' : ''}`}
// //                               disabled={isVerifying}
// //                               autoFocus
// //                             />
// //                             <button
// //                               type="button"
// //                               className="password-toggle-btn"
// //                               onClick={() => setShowPaymentPassword(!showPaymentPassword)}
// //                             >
// //                               {showPaymentPassword ? <FaEyeSlash /> : <FaEye />}
// //                             </button>
// //                           </div>
// //                           <Button
// //                             type="submit"
// //                             className="verify-btn"
// //                             disabled={isVerifying || !paymentViewPassword}
// //                           >
// //                             {isVerifying ? (
// //                               <>
// //                                 <span className="spinner-border spinner-border-sm me-2" />
// //                                 Verifying...
// //                               </>
// //                             ) : (
// //                               <>
// //                                 <FaLock /> Verify Password
// //                               </>
// //                             )}
// //                           </Button>
// //                         </div>
// //                         {paymentErrors.password && (
// //                           <span className="error-message">{paymentErrors.password}</span>
// //                         )}
// //                       </form>

// //                     </div>
// //                   ) : (
// //                     // Payment Details Display
// //                     <>
// //                       {!paymentEditable ? (
// //                         // View Mode
// //                         <div className="payment-view-mode">
// //                           <div className="payment-summary">
// //                             <div className="payment-method-display">
// //                               <div className="method-icon-large">
// //                                 {paymentDetails.payment_method === 'mpesa' ? (
// //                                   <FaMobileAlt />
// //                                 ) : (
// //                                   <FaUniversity />
// //                                 )}
// //                               </div>
// //                               <div className="method-info">
// //                                 <h4>Payment Method</h4>
// //                                 <p>
// //                                   {paymentDetails.payment_method === 'mpesa'
// //                                     ? 'M-Pesa'
// //                                     : 'Bank Transfer'}
// //                                 </p>
// //                               </div>
// //                             </div>

// //                             {paymentDetails.payment_method === 'mpesa' ? (
// //                               <>
// //                                 <div className="detail-item">
// //                                   <span className="detail-label">Phone Number</span>
// //                                   <span className="detail-value masked">
// //                                     {maskPhoneNumber(paymentDetails.mpesa_phone_number)}
// //                                   </span>
// //                                 </div>
// //                                 {paymentDetails.mpesa_name && (
// //                                   <div className="detail-item">
// //                                     <span className="detail-label">Account Name</span>
// //                                     <span className="detail-value">
// //                                       {paymentDetails.mpesa_name}
// //                                     </span>
// //                                   </div>
// //                                 )}
// //                               </>
// //                             ) : (
// //                               <>
// //                                 <div className="detail-item">
// //                                   <span className="detail-label">Bank Name</span>
// //                                   <span className="detail-value masked">
// //                                     {maskBankName(paymentDetails.bank_name)}
// //                                   </span>
// //                                 </div>
// //                                 <div className="detail-item">
// //                                   <span className="detail-label">Account Name</span>
// //                                   <span className="detail-value masked">
// //                                     {maskAccountName(paymentDetails.bank_account_name)}
// //                                   </span>
// //                                 </div>
// //                                 <div className="detail-item">
// //                                   <span className="detail-label">Account Number</span>
// //                                   <span className="detail-value masked">
// //                                     {maskAccountNumber(paymentDetails.bank_account_number)}
// //                                   </span>
// //                                 </div>
// //                                 {paymentDetails.bank_branch && (
// //                                   <div className="detail-item">
// //                                     <span className="detail-label">Branch</span>
// //                                     <span className="detail-value">
// //                                       {paymentDetails.bank_branch}
// //                                     </span>
// //                                   </div>
// //                                 )}
// //                               </>
// //                             )}
// //                           </div>

// //                           <div className="payment-actions">
// //                             <Button
// //                               className="edit-payment-btn"
// //                               onClick={enablePaymentEdit}
// //                             >
// //                               <FaEdit /> Edit Payment Details
// //                             </Button>
// //                           </div>
// //                         </div>
// //                       ) : (
// //                         // Edit Mode
// //                         <Form onSubmit={savePaymentDetails} className="payment-form">
// //                           <div className="payment-methods-section">
// //                             <h5>Select Payment Method</h5>
// //                             <div className="payment-methods">
// //                               <div
// //                                 className={`method-option ${paymentDetails.payment_method === 'mpesa' ? 'active' : ''}`}
// //                                 onClick={() => handlePaymentMethodChange('mpesa')}
// //                               >
// //                                 <div className="method-icon">
// //                                   <FaMobileAlt />
// //                                 </div>
// //                                 <div className="method-info">
// //                                   <h4>M-Pesa</h4>
// //                                   <p>Receive payments directly to your M-Pesa</p>
// //                                 </div>
// //                                 {paymentDetails.payment_method === 'mpesa' && (
// //                                   <div className="check-mark">
// //                                     <FaCheck />
// //                                   </div>
// //                                 )}
// //                               </div>

// //                               <div
// //                                 className={`method-option ${paymentDetails.payment_method === 'bank' ? 'active' : ''}`}
// //                                 onClick={() => handlePaymentMethodChange('bank')}
// //                               >
// //                                 <div className="method-icon">
// //                                   <FaUniversity />
// //                                 </div>
// //                                 <div className="method-info">
// //                                   <h4>Bank Transfer</h4>
// //                                   <p>Receive payments directly to your bank account</p>
// //                                 </div>
// //                                 {paymentDetails.payment_method === 'bank' && (
// //                                   <div className="check-mark">
// //                                     <FaCheck />
// //                                   </div>
// //                                 )}
// //                               </div>
// //                             </div>
// //                           </div>

// //                           {/* M-Pesa Fields */}
// //                           {paymentDetails.payment_method === 'mpesa' && (
// //                             <div className="form-group">
// //                               <label htmlFor="mpesa_phone_number">
// //                                 M-Pesa Phone Number <span className="required">*</span>
// //                               </label>
// //                               <input
// //                                 type="tel"
// //                                 id="mpesa_phone_number"
// //                                 name="mpesa_phone_number"
// //                                 value={paymentDetails.mpesa_phone_number}
// //                                 onChange={handlePaymentInputChange}
// //                                 placeholder="e.g., 0712345678"
// //                                 className={paymentErrors.mpesa_phone_number ? 'error' : ''}
// //                               />
// //                               {paymentErrors.mpesa_phone_number && (
// //                                 <span className="error-message">{paymentErrors.mpesa_phone_number}</span>
// //                               )}
// //                               <small className="hint">
// //                                 Enter the phone number registered with M-Pesa
// //                               </small>
// //                             </div>
// //                           )}

// //                           {/* Bank Fields */}
// //                           {paymentDetails.payment_method === 'bank' && (
// //                             <div className="bank-fields">
// //                               <div className="form-group">
// //                                 <label htmlFor="bank_name">
// //                                   Bank Name <span className="required">*</span>
// //                                 </label>
// //                                 <input
// //                                   type="text"
// //                                   id="bank_name"
// //                                   name="bank_name"
// //                                   value={paymentDetails.bank_name}
// //                                   onChange={handlePaymentInputChange}
// //                                   placeholder="e.g., KCB, Equity, Co-operative"
// //                                   className={paymentErrors.bank_name ? 'error' : ''}
// //                                 />
// //                                 {paymentErrors.bank_name && (
// //                                   <span className="error-message">{paymentErrors.bank_name}</span>
// //                                 )}
// //                               </div>

// //                               <div className="form-group">
// //                                 <label htmlFor="bank_account_name">
// //                                   Account Name <span className="required">*</span>
// //                                 </label>
// //                                 <input
// //                                   type="text"
// //                                   id="bank_account_name"
// //                                   name="bank_account_name"
// //                                   value={paymentDetails.bank_account_name}
// //                                   onChange={handlePaymentInputChange}
// //                                   placeholder="Full name on the bank account"
// //                                   className={paymentErrors.bank_account_name ? 'error' : ''}
// //                                 />
// //                                 {paymentErrors.bank_account_name && (
// //                                   <span className="error-message">{paymentErrors.bank_account_name}</span>
// //                                 )}
// //                               </div>

// //                               <div className="form-group">
// //                                 <label htmlFor="bank_account_number">
// //                                   Account Number <span className="required">*</span>
// //                                 </label>
// //                                 <input
// //                                   type="text"
// //                                   id="bank_account_number"
// //                                   name="bank_account_number"
// //                                   value={paymentDetails.bank_account_number}
// //                                   onChange={handlePaymentInputChange}
// //                                   placeholder="Your bank account number"
// //                                   className={paymentErrors.bank_account_number ? 'error' : ''}
// //                                 />
// //                                 {paymentErrors.bank_account_number && (
// //                                   <span className="error-message">{paymentErrors.bank_account_number}</span>
// //                                 )}
// //                               </div>

// //                               <div className="form-group">
// //                                 <label htmlFor="bank_branch">Bank Branch (Optional)</label>
// //                                 <input
// //                                   type="text"
// //                                   id="bank_branch"
// //                                   name="bank_branch"
// //                                   value={paymentDetails.bank_branch}
// //                                   onChange={handlePaymentInputChange}
// //                                   placeholder="e.g., Nairobi, Mombasa Road"
// //                                 />
// //                               </div>
// //                             </div>
// //                           )}

// //                           <div className="form-actions payment-actions">
// //                             <Button
// //                               type="button"
// //                               variant="secondary"
// //                               onClick={cancelPaymentEdit}
// //                               disabled={isPaymentLoading}
// //                             >
// //                               <FaTimes /> Cancel
// //                             </Button>
// //                             <Button
// //                               type="submit"
// //                               className="save-payment-btn"
// //                               disabled={isPaymentLoading}
// //                             >
// //                               {isPaymentLoading ? (
// //                                 <>
// //                                   <span className="spinner-border spinner-border-sm me-2" />
// //                                   Saving...
// //                                 </>
// //                               ) : (
// //                                 <>
// //                                   <FaCheck /> Save Changes
// //                                 </>
// //                               )}
// //                             </Button>
// //                           </div>
// //                         </Form>
// //                       )}
// //                     </>
// //                   )}
// //                 </div>
// //               </div>
// //             )}

// //             {/* LEGACY PROJECT TAB */}
// //             {activeTab === 'legacy' && (
// //               <div className="profile-card legacy-form-container">
// //                 <div className="card-header">
// //                   <h3>Add Legacy Project</h3>
// //                   <p className="mb-0">
// //                     Showcase your best work to attract more clients. You can add
// //                     up to 5 projects.
// //                   </p>
// //                   <div className="legacy-progress-info">
// //                     <span>
// //                       Used: <strong>{legacyCount}</strong> of{' '}
// //                       {maxLegacyProjects}
// //                     </span>
// //                     <span>
// //                       Remaining: <strong>{remainingLegacySlots}</strong>
// //                     </span>
// //                   </div>
// //                 </div>

// //                 <div className="card-content-legacy">
// //                   <Form onSubmit={saveLegacyProject} className="legacy-form">
// //                     <div className="form-row">
// //                       <Form.Group className="form-group-custom">
// //                         <Form.Label className="form-label-with-icon">
// //                           <FaEdit className="label-icon" /> Project Title
// //                         </Form.Label>
// //                         <Form.Control
// //                           type="text"
// //                           name="title"
// //                           value={legacyForm.title}
// //                           onChange={handleLegacyChange}
// //                           placeholder="e.g., Custom Oak Dining Table"
// //                           className="form-control-lg"
// //                           required
// //                         />
// //                         <Form.Text className="text-muted">
// //                           Give your project a descriptive name
// //                         </Form.Text>
// //                       </Form.Group>

// //                       <Form.Group className="form-group-custom">
// //                         <Form.Label className="form-label-with-icon">
// //                           <FaStar className="label-icon" /> Your Rating
// //                         </Form.Label>
// //                         <div className="rating-selector">
// //                           {[1, 2, 3, 4, 5].map((star) => (
// //                             <button
// //                               key={star}
// //                               type="button"
// //                               className={`rating-star-btn ${
// //                                 legacyForm.rating >= star ? 'selected' : ''
// //                               }`}
// //                               onClick={() =>
// //                                 setLegacyForm((prev) => ({
// //                                   ...prev,
// //                                   rating: star,
// //                                 }))
// //                               }
// //                             >
// //                               <FaStar />
// //                             </button>
// //                           ))}
// //                           <span className="rating-value">
// //                             ({legacyForm.rating}/5)
// //                           </span>
// //                         </div>
// //                       </Form.Group>
// //                     </div>

// //                     <Form.Group className="form-group-custom">
// //                       <Form.Label className="form-label-with-icon">
// //                         <FaEdit className="label-icon" /> Project Description
// //                       </Form.Label>
// //                       <Form.Control
// //                         as="textarea"
// //                         name="description"
// //                         value={legacyForm.description}
// //                         onChange={handleLegacyChange}
// //                         rows={4}
// //                         placeholder="Describe the project details, materials used, challenges overcome, client requirements..."
// //                         className="form-control-lg"
// //                         required
// //                       />
// //                       <div className="description-counter">
// //                         <span>{legacyForm.description.length}</span>/500
// //                         characters
// //                       </div>
// //                     </Form.Group>

// //                     <Form.Group className="form-group-custom">
// //                       <Form.Label className="form-label-with-icon">
// //                         <FaCamera className="label-icon" /> Project Images
// //                       </Form.Label>
// //                       <div className="image-upload-container">
// //                         <div
// //                           className="image-upload-area"
// //                           onClick={() =>
// //                             document.getElementById('legacyImageInput').click()
// //                           }
// //                         >
// //                           {legacyForm.images.length > 0 ? (
// //                             <div className="selected-images-preview">
// //                               <div className="images-count-badge">
// //                                 {legacyForm.images.length} image(s) selected
// //                               </div>
// //                               <div className="image-preview-grid">
// //                                 {Array.from(legacyForm.images)
// //                                   .slice(0, 3)
// //                                   .map((file, index) => (
// //                                     <div
// //                                       key={index}
// //                                       className="image-preview-item"
// //                                     >
// //                                       <img
// //                                         src={URL.createObjectURL(file)}
// //                                         alt={`Preview ${index + 1}`}
// //                                       />
// //                                       {index === 2 &&
// //                                         legacyForm.images.length > 3 && (
// //                                           <div className="more-images-overlay">
// //                                             +{legacyForm.images.length - 3}
// //                                           </div>
// //                                         )}
// //                                     </div>
// //                                   ))}
// //                               </div>
// //                             </div>
// //                           ) : (
// //                             <div className="upload-placeholder">
// //                               <div className="upload-icon">
// //                                 <FaImage />
// //                               </div>
// //                               <h5>Click to upload images</h5>
// //                               <p>Drag & drop or click to browse</p>
// //                               <p className="upload-hint">
// //                                 Supports JPG, PNG, WEBP up to 5MB each
// //                               </p>
// //                             </div>
// //                           )}
// //                           <input
// //                             type="file"
// //                             id="legacyImageInput"
// //                             name="images"
// //                             multiple
// //                             onChange={handleLegacyChange}
// //                             accept="image/*"
// //                             style={{ display: 'none' }}
// //                           />
// //                         </div>
// //                       </div>
// //                     </Form.Group>

// //                     <div className="form-actions legacy-form-actions">
// //                       <Button
// //                         type="submit"
// //                         className="submit-legacy-btn"
// //                         disabled={isLoading || remainingLegacySlots <= 0}
// //                       >
// //                         {isLoading ? (
// //                           <>
// //                             <span
// //                               className="spinner-border spinner-border-sm me-2"
// //                               role="status"
// //                             />
// //                             Adding Project...
// //                           </>
// //                         ) : (
// //                           <>
// //                             <FaPlus className="me-2" />
// //                             Add to Portfolio
// //                           </>
// //                         )}
// //                       </Button>
// //                       {remainingLegacySlots <= 0 && (
// //                         <div className="limit-reached-warning">
// //                           <FaExclamationTriangle className="warning-icon" />
// //                           You have reached the maximum of {maxLegacyProjects} legacy projects
// //                         </div>
// //                       )}
// //                     </div>
// //                   </Form>
// //                 </div>
// //               </div>
// //             )}

// //             {/* PORTFOLIO TAB */}
// //             {activeTab === 'portfolio' && (
// //               <div className="profile-card">
// //                 <div className="card-header">
// //                   <h3>My Portfolio</h3>
// //                   <p>Showcase your craftsmanship and completed projects</p>
// //                 </div>

// //                 {/* Legacy Projects Disclaimer */}
// //                 <div className="legacy-disclaimer">
// //                   <div className="disclaimer-icon">
// //                     <FaInfoCircle />
// //                   </div>
// //                   <div className="disclaimer-content">
// //                     <h5>About Legacy Projects</h5>
// //                     <p>
// //                       <strong>Legacy projects</strong> are projects you've
// //                       completed outside of our platform. They allow you to
// //                       showcase your experience and skills to potential clients,
// //                       even if the work wasn't done through our marketplace.
// //                     </p>
// //                     <div className="disclaimer-stats">
// //                       <div className="stat-item">
// //                         <span className="stat-label">Projects Added:</span>
// //                         <span className="stat-value">{legacyCount}</span>
// //                       </div>
// //                       <div className="stat-item">
// //                         <span className="stat-label">Remaining Slots:</span>
// //                         <span className="stat-value">
// //                           {remainingLegacySlots}
// //                         </span>
// //                       </div>
// //                       <div className="stat-item">
// //                         <span className="stat-label">Maximum Allowed:</span>
// //                         <span className="stat-value">{maxLegacyProjects}</span>
// //                       </div>
// //                     </div>
// //                     <div className="disclaimer-progress">
// //                       <div
// //                         className="progress-bar"
// //                         style={{
// //                           width: `${(legacyCount / maxLegacyProjects) * 100}%`,
// //                           background:
// //                             legacyCount >= maxLegacyProjects
// //                               ? '#dc3545'
// //                               : legacyCount >= maxLegacyProjects * 0.8
// //                                 ? '#ffc107'
// //                                 : '#28a745',
// //                         }}
// //                       />
// //                     </div>
// //                     <div className="disclaimer-note">
// //                       <small>
// //                         {legacyCount >= maxLegacyProjects
// //                           ? '✓ You have reached the maximum number of legacy projects.'
// //                           : `💡 You can add ${remainingLegacySlots} more legacy project${remainingLegacySlots > 1 ? 's' : ''} to your portfolio.`}
// //                       </small>
// //                     </div>
// //                   </div>
// //                 </div>

// //                 {/* Stats */}
// //                 <div className="artisan-stats">
// //                   <div className="stat-card">
// //                     <div className="stat-icon">
// //                       <FaAward />
// //                     </div>
// //                     <div className="stat-content">
// //                       <h4>{profile.experience_years}</h4>
// //                       <p>Years Experience</p>
// //                     </div>
// //                   </div>
// //                   <div className="stat-card">
// //                     <div className="stat-icon">
// //                       <FaImage />
// //                     </div>
// //                     <div className="stat-content">
// //                       <h4>{portfolio.length}</h4>
// //                       <p>Projects Showcased</p>
// //                     </div>
// //                   </div>
// //                   <div className="stat-card">
// //                     <div className="stat-icon">
// //                       <FaStar />
// //                     </div>
// //                     <div className="stat-content">
// //                       <h4>{profile.rating}</h4>
// //                       <p>Client Rating</p>
// //                     </div>
// //                   </div>
// //                   <div className="stat-card">
// //                     <div className="stat-icon">
// //                       <FaCheck />
// //                     </div>
// //                     <div className="stat-content">
// //                       <h4>{profile.completed_projects}</h4>
// //                       <p>Projects Completed</p>
// //                     </div>
// //                   </div>
// //                 </div>

// //                 {/* Portfolio */}
// //                 {portfolio.length > 0 ? (
// //                   <div className="portfolio-container">
// //                     {portfolio.map((item) => (
// //                       <div className="portfolio-item" key={item.id}>
// //                         <div className="portfolio-gallery">
// //                           {item.images && item.images.length > 0 ? (
// //                             <Carousel
// //                               variant="dark"
// //                               indicators={item.images.length > 1}
// //                               controls={item.images.length > 1}
// //                               interval={null}
// //                             >
// //                               {item.images.map((image, index) => (
// //                                 <Carousel.Item key={index}>
// //                                   <img
// //                                     className="d-block w-100"
// //                                     src={image.image}
// //                                     alt={`Project ${item.title} - ${index + 1}`}
// //                                   />
// //                                 </Carousel.Item>
// //                               ))}
// //                             </Carousel>
// //                           ) : (
// //                             <div className="image-placeholder">
// //                               <FaImage />
// //                               <span>No images available</span>
// //                             </div>
// //                           )}
// //                         </div>
// //                         <div className="portfolio-content">
// //                           <div className="project-header">
// //                             <h5>{item.title}</h5>
// //                             {item.rating && (
// //                               <div className="project-rating">
// //                                 <FaStar className="rating-star" />
// //                                 <span>{item.rating}</span>
// //                               </div>
// //                             )}
// //                           </div>
// //                           <p className="project-description">
// //                             {item.description || 'No description provided.'}
// //                           </p>
// //                         </div>
// //                       </div>
// //                     ))}
// //                   </div>
// //                 ) : (
// //                   <div className="empty-portfolio">
// //                     <div className="empty-icon">
// //                       <FaImage />
// //                     </div>
// //                     <h5>No Projects Yet</h5>
// //                     <p>
// //                       Start building your portfolio by adding your completed
// //                       projects in the add legacy portfolio. Showcase your
// //                       craftsmanship and attract more clients.
// //                     </p>
// //                     {remainingLegacySlots > 0 && (
// //                       <Button
// //                         className="add-first-project-btn"
// //                         onClick={() => setActiveTab('legacy')}
// //                       >
// //                         <FaPlus /> Add Your First Project
// //                       </Button>
// //                     )}
// //                   </div>
// //                 )}
// //               </div>
// //             )}
// //           </div>
// //         </div>
// //       </div>

// //       {/* Crop Modal */}
// //       <Modal
// //         show={showCropModal}
// //         onHide={cancelCrop}
// //         size="lg"
// //         centered
// //         backdrop="static"
// //       >
// //         <Modal.Header closeButton>
// //           <Modal.Title>
// //             <FaCrop className="me-2" /> Crop Avatar Image
// //           </Modal.Title>
// //         </Modal.Header>
// //         <Modal.Body>
// //           <div className="crop-container" style={{ textAlign: 'center' }}>
// //             {selectedImage && (
// //               <ReactCrop
// //                 crop={crop}
// //                 onChange={(c) => setCrop(c)}
// //                 onComplete={onCropComplete}
// //                 aspect={1}
// //                 circularCrop
// //                 className="react-crop"
// //                 style={{ maxHeight: '500px' }}
// //               >
// //                 <img
// //                   ref={imgRef}
// //                   src={selectedImage}
// //                   alt="Crop preview"
// //                   style={{ maxWidth: '100%' }}
// //                   onLoad={() => {
// //                     const img = imgRef.current;
// //                     if (img) {
// //                       const { width, height } = img;
// //                       const cropSize = Math.min(width, height) * 0.8;
// //                       const cropX = (width - cropSize) / 2;
// //                       const cropY = (height - cropSize) / 2;
// //                       setCrop({
// //                         unit: 'px',
// //                         width: cropSize,
// //                         height: cropSize,
// //                         x: cropX,
// //                         y: cropY,
// //                       });
// //                     }
// //                   }}
// //                 />
// //               </ReactCrop>
// //             )}
// //             <div className="mt-3 text-muted small">
// //               <FaCamera className="me-1" /> Drag the corners to select the area
// //               you want to keep. The image will be cropped to a perfect square.
// //             </div>
// //           </div>
// //         </Modal.Body>
// //         <Modal.Footer>
// //           <Button variant="secondary" onClick={cancelCrop}>
// //             <FaTimesCircle /> Cancel
// //           </Button>
// //           <Button variant="primary" onClick={applyCrop} className="crop-apply">
// //             <FaCrop /> Apply Crop
// //           </Button>
// //         </Modal.Footer>
// //       </Modal>
// //     </>
// //   );
// // };

// // export default withAuth(ArtisanProfile, 'artisan');

// // ArtisanProfile.jsx — Workshop Dashboard redesign
// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import Sidebar from '../../../components/layout/Sidebar';
// import './artisanprofile.scss';
// import withAuth from '../../auth/WithAuth';
// import defaultAvatar from '../../../assets/DefaultProfile.png';
// import {
//   FaUser,
//   FaEnvelope,
//   FaPhone,
//   FaCamera,
//   FaCheck,
//   FaExclamationTriangle,
//   FaEdit,
//   FaTimes,
//   FaImage,
//   FaStar,
//   FaAward,
//   FaPlus,
//   FaTrash,
//   FaArrowRight,
//   FaCrop,
//   FaTimesCircle,
//   FaInfoCircle,
//   FaLocationArrow,
//   FaWallet,
//   FaMobileAlt,
//   FaUniversity,
//   FaLock,
//   FaEye,
//   FaEyeSlash,
// } from 'react-icons/fa';
// import Button from 'react-bootstrap/Button';
// import Form from 'react-bootstrap/Form';
// import Alert from 'react-bootstrap/Alert';
// import Carousel from 'react-bootstrap/Carousel';
// import Modal from 'react-bootstrap/Modal';
// import { serverUrlAuth } from '../../../serverUrl';
// import { toast } from 'react-toastify';
// import ReactCrop from 'react-image-crop';
// import 'react-image-crop/dist/ReactCrop.css';

// const ArtisanProfile = () => {
//   const navigate = useNavigate();
//   const [activeTab, setActiveTab] = useState('profile');
//   const [profile, setProfile] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     avatar: defaultAvatar,
//     location: '',
//     experience_years: 0,
//     rating: 0,
//     completed_projects: 0,
//   });
//   const [editable, setEditable] = useState(false);
//   const [alerts, setAlerts] = useState({
//     profile: '',
//     legacy: '',
//     portfolio: '',
//     payment: '',
//   });
//   const [isLoading, setIsLoading] = useState(false);

//   const [portfolioData, setPortfolioData] = useState(null);
//   const [portfolio, setPortfolio] = useState([]);
//   const [artisanProfile, setArtisanProfile] = useState([]);
//   const [legacyForm, setLegacyForm] = useState({
//     title: '',
//     description: '',
//     rating: 1,
//     images: [],
//   });
//   const fileInputRef = useRef(null);

//   const [paymentDetails, setPaymentDetails] = useState({
//     payment_method: '',
//     mpesa_phone_number: '',
//     mpesa_name: '',
//     bank_name: '',
//     bank_account_name: '',
//     bank_account_number: '',
//     bank_branch: '',
//   });
//   const [paymentViewPassword, setPaymentViewPassword] = useState('');
//   const [showPaymentPassword, setShowPaymentPassword] = useState(false);
//   const [isPaymentVerified, setIsPaymentVerified] = useState(false);
//   const [isPaymentLoading, setIsPaymentLoading] = useState(false);
//   const [paymentEditable, setPaymentEditable] = useState(false);
//   const [paymentErrors, setPaymentErrors] = useState({});
//   const [isVerifying, setIsVerifying] = useState(false);

//   const [showCropModal, setShowCropModal] = useState(false);
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [crop, setCrop] = useState({
//     unit: '%',
//     width: 80,
//     height: 80,
//     x: 10,
//     y: 10,
//   });
//   const [completedCrop, setCompletedCrop] = useState(null);
//   const [croppedImageUrl, setCroppedImageUrl] = useState(null);
//   const [croppedImageFile, setCroppedImageFile] = useState(null);
//   const imgRef = useRef(null);

//   const fetchProfile = async () => {
//     try {
//       const res = await serverUrlAuth.get('users/profile/');
//       const data = res.data;
//       setProfile((prev) => ({
//         ...prev,
//         name: data.full_name,
//         email: data.email,
//         phone: data.phone_number || '',
//         avatar: data.profile_picture || defaultAvatar,
//       }));
//     } catch (error) {
//       console.error('Failed to fetch profile:', error);
//     }
//   };

//   const fetchArtisanProfile = async () => {
//     try {
//       const response = await serverUrlAuth.get('users/artisan/profile/');
//       setArtisanProfile(response.data);
//       if (response.data) {
//         setProfile((prev) => ({
//           ...prev,
//           location: response.data.location || '',
//         }));
//       }
//     } catch (error) {
//       console.error('Failed to fetch artisan profile:', error);
//     }
//   };

//   useEffect(() => {
//     fetchProfile();
//     fetchArtisanProfile();
//   }, []);

//   const loadPortfolio = async () => {
//     try {
//       const res = await serverUrlAuth.get('portfolio/artisan-portfolio/');
//       const data = res.data;
//       setPortfolioData(data);
//       setPortfolio(data.portfolio_items || []);
//       setProfile((prev) => ({
//         ...prev,
//         experience_years: data.years_of_experience || 0,
//         rating: data.client_rating || 0,
//         completed_projects: data.projects_completed || 0,
//       }));
//     } catch (error) {
//       console.error('Failed to load portfolio:', error);
//       showAlert('portfolio', 'Failed to load portfolio', 'error');
//     }
//   };

//   useEffect(() => {
//     loadPortfolio();
//   }, []);

//   const showAlert = (type, message, variant = 'success') => {
//     setAlerts((prev) => ({ ...prev, [type]: { message, variant } }));
//     setTimeout(() => setAlerts((prev) => ({ ...prev, [type]: '' })), 5000);
//   };

//   const handleProfileChange = (e) => {
//     const { name, value } = e.target;
//     setProfile((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleAvatarChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       if (!file.type.startsWith('image/')) {
//         showAlert('profile', 'Please select a valid image', 'error');
//         return;
//       }
//       if (file.size > 5 * 1024 * 1024) {
//         showAlert('profile', 'Image must be less than 5MB', 'error');
//         return;
//       }
//       const reader = new FileReader();
//       reader.onload = () => {
//         setSelectedImage(reader.result);
//         setShowCropModal(true);
//         setCrop({ unit: '%', width: 80, height: 80, x: 10, y: 10 });
//         setCompletedCrop(null);
//         setCroppedImageUrl(null);
//         setCroppedImageFile(null);
//       };
//       reader.readAsDataURL(file);
//       e.target.value = null;
//     }
//   };

//   const triggerFileInput = () => editable && fileInputRef.current?.click();
//   const onCropComplete = (crop) => setCompletedCrop(crop);

//   const getCroppedImg = async () => {
//     if (!imgRef.current || !completedCrop) return;
//     try {
//       const canvas = document.createElement('canvas');
//       const image = imgRef.current;
//       const crop = completedCrop;
//       const scaleX = image.naturalWidth / image.width;
//       const scaleY = image.naturalHeight / image.height;
//       canvas.width = crop.width * scaleX;
//       canvas.height = crop.height * scaleY;
//       const ctx = canvas.getContext('2d');
//       ctx.imageSmoothingEnabled = true;
//       ctx.imageSmoothingQuality = 'high';
//       ctx.drawImage(
//         image,
//         crop.x * scaleX,
//         crop.y * scaleY,
//         crop.width * scaleX,
//         crop.height * scaleY,
//         0,
//         0,
//         crop.width * scaleX,
//         crop.height * scaleY,
//       );
//       return new Promise((resolve) => {
//         canvas.toBlob(
//           (blob) => {
//             if (blob) {
//               const url = URL.createObjectURL(blob);
//               const file = new File([blob], 'avatar.jpg', {
//                 type: 'image/jpeg',
//               });
//               resolve({ url, file });
//             }
//           },
//           'image/jpeg',
//           0.95,
//         );
//       });
//     } catch (error) {
//       console.error('Error cropping image:', error);
//       showAlert('profile', 'Failed to crop image', 'error');
//     }
//   };

//   const applyCrop = async () => {
//     if (!completedCrop) {
//       showAlert('profile', 'Please crop the image first', 'error');
//       return;
//     }
//     try {
//       const result = await getCroppedImg();
//       if (result) {
//         setCroppedImageUrl(result.url);
//         setCroppedImageFile(result.file);
//         setProfile((prev) => ({ ...prev, avatar: result.url }));
//         showAlert('profile', 'Avatar cropped successfully!', 'success');
//         setShowCropModal(false);
//       }
//     } catch (error) {
//       console.error('Error applying crop:', error);
//       showAlert('profile', 'Failed to apply crop', 'error');
//     }
//   };

//   const cancelCrop = () => {
//     setShowCropModal(false);
//     setSelectedImage(null);
//     setCroppedImageUrl(null);
//     setCroppedImageFile(null);
//     setCompletedCrop(null);
//   };

//   const toggleEdit = () => setEditable(true);
//   const cancelEdit = () => {
//     setEditable(false);
//     setCroppedImageUrl(null);
//     setCroppedImageFile(null);
//   };

//   const saveProfile = async (e) => {
//     e.preventDefault();
//     setIsLoading(true);
//     try {
//       const formData = new FormData();
//       formData.append('full_name', profile.name);
//       formData.append('phone_number', profile.phone);
//       formData.append('location', profile.location);
//       if (croppedImageFile)
//         formData.append('profile_picture', croppedImageFile);
//       else if (fileInputRef.current?.files[0])
//         formData.append('profile_picture', fileInputRef.current.files[0]);
//       const res = await serverUrlAuth.patch('users/profile/', formData, {
//         headers: { 'Content-Type': 'multipart/form-data' },
//       });
//       setProfile((prev) => ({
//         ...prev,
//         avatar: res.data.profile_picture || prev.avatar,
//       }));
//       setCroppedImageUrl(null);
//       setCroppedImageFile(null);
//       showAlert('profile', 'Profile updated successfully!', 'success');
//       setEditable(false);
//     } catch (error) {
//       console.error(error);
//       showAlert('profile', 'Failed to update profile', 'error');
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     return () => {
//       if (croppedImageUrl) URL.revokeObjectURL(croppedImageUrl);
//     };
//   }, [croppedImageUrl]);

//   const handleLegacyChange = (e) => {
//     const { name, value, files } = e.target;
//     if (name === 'images')
//       setLegacyForm((prev) => ({ ...prev, images: files }));
//     else setLegacyForm((prev) => ({ ...prev, [name]: value }));
//   };

//   const saveLegacyProject = async (e) => {
//     e.preventDefault();
//     setIsLoading(true);
//     try {
//       const formData = new FormData();
//       formData.append('title', legacyForm.title);
//       formData.append('description', legacyForm.description);
//       formData.append('rating', legacyForm.rating);
//       for (let i = 0; i < legacyForm.images.length; i++)
//         formData.append('images', legacyForm.images[i]);
//       const response = await serverUrlAuth.post(
//         'portfolio/artisan-portfolio/legacy/create/',
//         formData,
//       );
//       toast.success(
//         response.data.detail || 'Legacy project added successfully!',
//       );
//       setLegacyForm({ title: '', description: '', rating: 1, images: [] });
//       await loadPortfolio();
//       if (response.data.remaining_slots > 0)
//         toast.info(
//           `You have ${response.data.remaining_slots} more legacy project slots remaining.`,
//         );
//       else toast.info('You have reached the maximum of 5 legacy projects.');
//     } catch (err) {
//       console.error(err);
//       const msg =
//         err.response?.data?.detail ||
//         'Failed to add legacy project. Maybe you reached the 5-project limit.';
//       showAlert('legacy', msg, 'error');
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const verifyPaymentPassword = async (e) => {
//     e.preventDefault();
//     if (!paymentViewPassword) {
//       toast.error('Please enter your password');
//       return;
//     }
//     setIsVerifying(true);
//     try {
//       const response = await serverUrlAuth.post(
//         'users/payment-details/verify/',
//         { password: paymentViewPassword },
//       );
//       if (response.data.status) {
//         setIsPaymentVerified(true);
//         const details = response.data.payment_details;
//         setPaymentDetails({
//           payment_method: details.payment_method || 'mpesa',
//           mpesa_phone_number: details.mpesa_phone_number || '',
//           mpesa_name: details.mpesa_name || '',
//           bank_name: details.bank_name || '',
//           bank_account_name: details.bank_account_name || '',
//           bank_account_number: details.bank_account_number || '',
//           bank_branch: details.bank_branch || '',
//         });
//         toast.success(
//           response.data.message || 'Password verified successfully!',
//         );
//         setPaymentViewPassword('');
//         setPaymentErrors({});
//       }
//     } catch (error) {
//       console.error('Password verification failed:', error);
//       if (error.response?.data) {
//         toast.error(error.response.data.message || 'Invalid password');
//         setPaymentErrors({
//           password: error.response.data.message || 'Invalid password',
//         });
//       } else toast.error('Failed to verify password');
//       setPaymentViewPassword('');
//     } finally {
//       setIsVerifying(false);
//     }
//   };

//   const maskPhoneNumber = (phone) => {
//     if (!phone) return 'Not set';
//     if (phone.length <= 4) return phone;
//     return `${phone.slice(0, 4)}******${phone.slice(-2)}`;
//   };
//   const maskAccountNumber = (account) => {
//     if (!account) return 'Not set';
//     if (account.length <= 4) return account;
//     return `${account.slice(0, 4)}******`;
//   };
//   const maskAccountName = (name) => {
//     if (!name) return 'Not set';
//     if (name.length <= 3) return name;
//     return name.slice(0, 3) + name.slice(3).replace(/./g, '*');
//   };
//   const maskBankName = (name) => {
//     if (!name) return 'Not set';
//     if (name.length <= 3) return name;
//     return name.slice(0, 3) + name.slice(3).replace(/./g, '*');
//   };

//   const enablePaymentEdit = () => {
//     setPaymentEditable(true);
//     setPaymentErrors({});
//   };
//   const cancelPaymentEdit = () => {
//     setPaymentEditable(false);
//     setPaymentErrors({});
//     setIsPaymentVerified(false);
//     setPaymentViewPassword('');
//     toast.info('Please re-verify your password to view payment details');
//   };
//   const handlePaymentInputChange = (e) => {
//     const { name, value } = e.target;
//     setPaymentDetails((prev) => ({ ...prev, [name]: value }));
//     if (paymentErrors[name])
//       setPaymentErrors((prev) => ({ ...prev, [name]: '' }));
//   };
//   const handlePaymentMethodChange = (method) => {
//     setPaymentDetails((prev) => ({ ...prev, payment_method: method }));
//     setPaymentErrors({});
//   };

//   const validatePaymentDetails = () => {
//     const errors = {};
//     if (paymentDetails.payment_method === 'mpesa') {
//       if (!paymentDetails.mpesa_phone_number)
//         errors.mpesa_phone_number = 'Phone number is required';
//       else {
//         const phone = paymentDetails.mpesa_phone_number.replace(/\s/g, '');
//         const phoneRegex = /^(?:\+254|0)?[17]\d{8}$/;
//         if (!phoneRegex.test(phone))
//           errors.mpesa_phone_number =
//             'Please enter a valid Kenyan phone number (e.g., 0712345678)';
//       }
//     } else if (paymentDetails.payment_method === 'bank') {
//       if (!paymentDetails.bank_name) errors.bank_name = 'Bank name is required';
//       if (!paymentDetails.bank_account_name)
//         errors.bank_account_name = 'Account name is required';
//       if (!paymentDetails.bank_account_number)
//         errors.bank_account_number = 'Account number is required';
//     }
//     return errors;
//   };

//   const savePaymentDetails = async (e) => {
//     e.preventDefault();
//     const errors = validatePaymentDetails();
//     if (Object.keys(errors).length > 0) {
//       setPaymentErrors(errors);
//       return;
//     }
//     setIsPaymentLoading(true);
//     try {
//       const payload = {
//         payment_method: paymentDetails.payment_method,
//         mpesa_phone_number: paymentDetails.mpesa_phone_number,
//         bank_name: paymentDetails.bank_name,
//         bank_account_name: paymentDetails.bank_account_name,
//         bank_account_number: paymentDetails.bank_account_number,
//         bank_branch: paymentDetails.bank_branch,
//       };
//       const response = await serverUrlAuth.patch(
//         'users/artisan/profile/',
//         payload,
//       );
//       toast.success(
//         response.data.message || 'Payment details updated successfully!',
//       );
//       setPaymentEditable(false);
//       setPaymentErrors({});
//       setIsPaymentVerified(false);
//       setPaymentViewPassword('');
//       toast.info(
//         'Please re-verify your password to view updated payment details',
//       );
//     } catch (error) {
//       console.error('Error saving payment details:', error);
//       if (error.response?.data)
//         toast.error(
//           error.response.data.message || 'Failed to save payment details',
//         );
//       else toast.error('Failed to save payment details');
//     } finally {
//       setIsPaymentLoading(false);
//     }
//   };

//   const handleDeleteAccountClick = () => navigate('/delete-account');

//   const legacyCount = portfolioData?.legacy_projects_count || 0;
//   const maxLegacyProjects = 5;
//   const remainingLegacySlots = Math.max(0, maxLegacyProjects - legacyCount);

//   // "Stations" = tabs reimagined as workshop tools
//   const stations = [
//     { id: 'profile', icon: <FaUser />, label: 'Identity', sub: 'Your details' },
//     { id: 'payment', icon: <FaWallet />, label: 'Payment details', sub: 'Get paid' },
//     { id: 'portfolio', icon: <FaImage />, label: 'Portfolio', sub: 'Your work' },
//     ...(remainingLegacySlots > 0
//       ? [
//           {
//             id: 'legacy',
//             icon: <FaPlus />,
//             label: 'Add Legacy',
//             sub: `${remainingLegacySlots} left`,
//             badge: remainingLegacySlots,
//           },
//         ]
//       : []),
//   ];

//   return (
//     <>
//       <Sidebar />
//       <div className="modern-dashboard workshop-profile">
//         {/* ============================================================
//             WORKSHOP IDENTITY HERO — avatar bleeds out of the banner
//            ============================================================ */}
//         <section className="workshop-hero">
//           <div className="hero-pattern"></div>
//           <span className="hero-circle hero-circle-1"></span>
//           <span className="hero-circle hero-circle-2"></span>
//           <span className="hero-circle hero-circle-3"></span>
//           <span className="hero-circle hero-circle-4"></span>
//           <span className="hero-circle hero-circle-5"></span>
//           <span className="hero-circle hero-circle-6"></span>
//           <span className="hero-circle hero-circle-7"></span>
//           <span className="hero-circle hero-circle-8"></span>
//           <span className="hero-circle hero-circle-9"></span>
//           <span className="hero-circle hero-circle-10"></span>

//           <div className="hero-inner">
//             {/* Avatar lifted out of the banner */}
//             <div className="identity-avatar">
//               <img src={profile.avatar} alt={profile.name || 'Artisan'} />
//               {editable && (
//                 <button
//                   type="button"
//                   className="avatar-edit-btn"
//                   onClick={triggerFileInput}
//                   title="Change profile photo"
//                 >
//                   <FaCamera />
//                 </button>
//               )}
//               <input
//                 type="file"
//                 ref={fileInputRef}
//                 onChange={handleAvatarChange}
//                 accept="image/*"
//                 style={{ display: 'none' }}
//               />
//             </div>

//             <div className="identity-text">
//               <div className="identity-eyebrow">
//                 <span className="dot" /> Artisan Workshop
//               </div>
//               <h1 className="identity-name">{profile.name || 'Your Name'}</h1>
//               <div className="identity-meta">
//                 {profile.location && (
//                   <span className="meta-chip">
//                     <FaLocationArrow /> {profile.location}
//                   </span>
//                 )}
//                 {profile.rating > 0 && (
//                   <span className="meta-chip rating">
//                     <FaStar /> {profile.rating} rating
//                   </span>
//                 )}
//                 <span className="meta-chip">
//                   <FaAward /> {profile.experience_years} yrs experience
//                 </span>
//               </div>
//             </div>
//           </div>

//           {/* Floating stat pills that overlap the hero bottom edge */}
//           <div className="stat-floater">
//             <div className="float-pill">
//               <span className="pill-value">{profile.completed_projects}</span>
//               <span className="pill-label">Projects Done</span>
//             </div>
//             <div className="float-pill">
//               <span className="pill-value">{portfolio.length}</span>
//               <span className="pill-label">Portfolio Pieces</span>
//             </div>
//             <div className="float-pill">
//               <span className="pill-value">{profile.rating}</span>
//               <span className="pill-label">Client Rating</span>
//             </div>
//             <div className="float-pill">
//               <span className="pill-value">{profile.experience_years}</span>
//               <span className="pill-label">Years Crafting</span>
//             </div>
//           </div>
//         </section>

//         {/* ============================================================
//             HORIZONTAL STATION TABS
//            ============================================================ */}
//         <nav className="station-nav" aria-label="Workshop sections">
//           {stations.map((s) => (
//             <button
//               key={s.id}
//               className={`station ${activeTab === s.id ? 'active' : ''}`}
//               onClick={() => {
//                 setActiveTab(s.id);
//                 if (s.id === 'payment') {
//                   setIsPaymentVerified(false);
//                   setPaymentEditable(false);
//                   setPaymentViewPassword('');
//                   setPaymentErrors({});
//                 }
//               }}
//             >
//               <span className="station-icon">{s.icon}</span>
//               <span className="station-text">
//                 <span className="station-label">{s.label}</span>
//                 <span className="station-sub">{s.sub}</span>
//               </span>
//               {s.badge && <span className="station-badge">{s.badge}</span>}
//             </button>
//           ))}

//           <button className="station danger" onClick={handleDeleteAccountClick}>
//             <span className="station-icon">
//               <FaTrash />
//             </span>
//             <span className="station-text">
//               <span className="station-label">Danger Zone</span>
//               <span className="station-sub">Delete account</span>
//             </span>
//             <FaArrowRight className="station-arrow" />
//           </button>
//         </nav>

//         {/* ============================================================
//             WORKSHOP PANEL — content morphs per station
//            ============================================================ */}
//         <div className="workshop-panel">
//           {/* Alerts */}
//           {['profile', 'legacy', 'portfolio', 'payment'].map(
//             (type) =>
//               alerts[type] && (
//                 <Alert
//                   key={type}
//                   variant={alerts[type].variant}
//                   className="alert-custom"
//                 >
//                   {alerts[type].variant === 'success' ? (
//                     <FaCheck />
//                   ) : (
//                     <FaExclamationTriangle />
//                   )}
//                   {alerts[type].message}
//                 </Alert>
//               ),
//           )}

//           {/* Corner brackets for the "workshop" feel */}
//           <span className="corner tl" />
//           <span className="corner tr" />
//           <span className="corner bl" />
//           <span className="corner br" />

//           {/* Panel header ribbon */}
//           <header className="panel-ribbon">
//             <span className="ribbon-label">
//               {activeTab === 'profile' && 'Identity Station'}
//               {activeTab === 'payment' && 'Payments Station'}
//               {activeTab === 'legacy' && 'Add Legacy Piece'}
//               {activeTab === 'portfolio' && 'Gallery Wall'}
//             </span>
//             <span className="ribbon-line" />
//           </header>

//           {/* ================= PROFILE ================= */}
//           {activeTab === 'profile' && (
//             <Form onSubmit={saveProfile} className="panel-body">
//               <div className="split-panel">
//                 <aside className="split-aside">
//                   <div className="aside-badge">
//                     <FaUser />
//                   </div>
//                   <h4 className="aside-title">Your workshop identity</h4>
//                   <p className="aside-text">
//                     This is what clients see first. Keep it sharp — a clear
//                     name, a reachable phone, and a real location build trust
//                     before you even send a proposal.
//                   </p>
//                   <div className="aside-hint">
//                     <FaInfoCircle />
//                     <span>Email can't be changed here.</span>
//                   </div>
//                 </aside>

//                 <div className="split-main">
//                   <div className="field-grid">
//                     <div className="field">
//                       <label>
//                         <FaUser /> Full Name
//                       </label>
//                       <Form.Control
//                         type="text"
//                         name="name"
//                         value={profile.name}
//                         onChange={handleProfileChange}
//                         disabled={!editable}
//                         required
//                       />
//                     </div>
//                     <div className="field">
//                       <label>
//                         <FaEnvelope /> Email
//                       </label>
//                       <Form.Control
//                         type="email"
//                         value={profile.email}
//                         disabled
//                       />
//                     </div>
//                     <div className="field">
//                       <label>
//                         <FaPhone /> Phone
//                       </label>
//                       <Form.Control
//                         type="tel"
//                         name="phone"
//                         value={profile.phone}
//                         onChange={handleProfileChange}
//                         disabled={!editable}
//                       />
//                     </div>
//                     <div className="field">
//                       <label>
//                         <FaLocationArrow /> Location
//                       </label>
//                       <Form.Control
//                         type="text"
//                         name="location"
//                         value={artisanProfile.location || ''}
//                         disabled
//                       />
//                     </div>
//                   </div>

//                   <div className="panel-actions">
//                     {!editable ? (
//                       <button
//                         type="button"
//                         className="btn-craft"
//                         onClick={toggleEdit}
//                       >
//                         <FaEdit /> Edit Identity
//                       </button>
//                     ) : (
//                       <>
//                         <button
//                           type="submit"
//                           className="btn-craft"
//                           disabled={isLoading}
//                         >
//                           {isLoading ? (
//                             'Saving…'
//                           ) : (
//                             <>
//                               <FaCheck /> Save Changes
//                             </>
//                           )}
//                         </button>
//                         <button
//                           type="button"
//                           className="btn-ghost"
//                           onClick={cancelEdit}
//                         >
//                           <FaTimes /> Cancel
//                         </button>
//                       </>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </Form>
//           )}

//           {/* ================= PAYMENT ================= */}
//           {activeTab === 'payment' && (
//             <div className="panel-body">
//               {!isPaymentVerified ? (
//                 <div className="vault-lock">
//                   <div className="vault-ring">
//                     <FaLock />
//                   </div>
//                   <h4 className="vault-title">Vault Access Required</h4>
//                   <p className="vault-text">
//                     Your payment details are locked. Enter your password to
//                     unlock them — this keeps your financial info safe even if
//                     someone else has your device.
//                   </p>
//                   <Form onSubmit={verifyPaymentPassword} className="vault-form">
//                     <div className="vault-input">
//                       <Form.Control
//                         type={showPaymentPassword ? 'text' : 'password'}
//                         placeholder="Enter your password"
//                         value={paymentViewPassword}
//                         onChange={(e) => {
//                           setPaymentViewPassword(e.target.value);
//                           setPaymentErrors({});
//                         }}
//                         className={paymentErrors.password ? 'error' : ''}
//                         disabled={isVerifying}
//                         autoFocus
//                       />
//                       <button
//                         type="button"
//                         className="vault-toggle"
//                         onClick={() =>
//                           setShowPaymentPassword(!showPaymentPassword)
//                         }
//                         tabIndex={-1}
//                       >
//                         {showPaymentPassword ? <FaEyeSlash /> : <FaEye />}
//                       </button>
//                     </div>
//                     <button
//                       type="submit"
//                       className="btn-craft"
//                       disabled={isVerifying || !paymentViewPassword}
//                     >
//                       {isVerifying ? (
//                         <>Verifying…</>
//                       ) : (
//                         <>
//                           <FaLock /> Unlock
//                         </>
//                       )}
//                     </button>
//                   </Form>
//                   {paymentErrors.password && (
//                     <span className="error-message">
//                       {paymentErrors.password}
//                     </span>
//                   )}
//                 </div>
//               ) : !paymentEditable ? (
//                 <div className="vault-view">
//                   <div className="vault-method">
//                     <div className="vault-method-icon">
//                       {paymentDetails.payment_method === 'mpesa' ? (
//                         <FaMobileAlt />
//                       ) : (
//                         <FaUniversity />
//                       )}
//                     </div>
//                     <div>
//                       <span className="vault-method-label">Payment Method</span>
//                       <span className="vault-method-value">
//                         {paymentDetails.payment_method === 'mpesa'
//                           ? 'M-Pesa'
//                           : 'Bank Transfer'}
//                       </span>
//                     </div>
//                   </div>

//                   <div className="vault-fields">
//                     {paymentDetails.payment_method === 'mpesa' ? (
//                       <>
//                         <div className="vault-field">
//                           <span className="vault-label">Phone Number</span>
//                           <span className="vault-value masked">
//                             {maskPhoneNumber(paymentDetails.mpesa_phone_number)}
//                           </span>
//                         </div>
//                         {paymentDetails.mpesa_name && (
//                           <div className="vault-field">
//                             <span className="vault-label">Account Name</span>
//                             <span className="vault-value">
//                               {paymentDetails.mpesa_name}
//                             </span>
//                           </div>
//                         )}
//                       </>
//                     ) : (
//                       <>
//                         <div className="vault-field">
//                           <span className="vault-label">Bank Name</span>
//                           <span className="vault-value masked">
//                             {maskBankName(paymentDetails.bank_name)}
//                           </span>
//                         </div>
//                         <div className="vault-field">
//                           <span className="vault-label">Account Name</span>
//                           <span className="vault-value masked">
//                             {maskAccountName(paymentDetails.bank_account_name)}
//                           </span>
//                         </div>
//                         <div className="vault-field">
//                           <span className="vault-label">Account Number</span>
//                           <span className="vault-value masked">
//                             {maskAccountNumber(
//                               paymentDetails.bank_account_number,
//                             )}
//                           </span>
//                         </div>
//                         {paymentDetails.bank_branch && (
//                           <div className="vault-field">
//                             <span className="vault-label">Branch</span>
//                             <span className="vault-value">
//                               {paymentDetails.bank_branch}
//                             </span>
//                           </div>
//                         )}
//                       </>
//                     )}
//                   </div>

//                   <div className="panel-actions">
//                     <button
//                       type="button"
//                       className="btn-craft"
//                       onClick={enablePaymentEdit}
//                     >
//                       <FaEdit /> Edit Payment Details
//                     </button>
//                   </div>
//                 </div>
//               ) : (
//                 <Form onSubmit={savePaymentDetails} className="vault-form-edit">
//                   <div className="vault-section">
//                     <h5 className="vault-section-title">
//                       Choose how you get paid
//                     </h5>
//                     <div className="vault-methods">
//                       <button
//                         type="button"
//                         className={`vault-method-pick ${paymentDetails.payment_method === 'mpesa' ? 'active' : ''}`}
//                         onClick={() => handlePaymentMethodChange('mpesa')}
//                       >
//                         <FaMobileAlt />
//                         <div>
//                           <strong>M-Pesa</strong>
//                           <span>Send to your phone</span>
//                         </div>
//                         {paymentDetails.payment_method === 'mpesa' && (
//                           <FaCheck className="pick-check" />
//                         )}
//                       </button>
//                       <button
//                         type="button"
//                         className={`vault-method-pick ${paymentDetails.payment_method === 'bank' ? 'active' : ''}`}
//                         onClick={() => handlePaymentMethodChange('bank')}
//                       >
//                         <FaUniversity />
//                         <div>
//                           <strong>Bank Transfer</strong>
//                           <span>Direct to your bank</span>
//                         </div>
//                         {paymentDetails.payment_method === 'bank' && (
//                           <FaCheck className="pick-check" />
//                         )}
//                       </button>
//                     </div>
//                   </div>

//                   {paymentDetails.payment_method === 'mpesa' && (
//                     <div className="field">
//                       <label>
//                         M-Pesa Phone Number <span className="required">*</span>
//                       </label>
//                       <input
//                         type="tel"
//                         name="mpesa_phone_number"
//                         value={paymentDetails.mpesa_phone_number}
//                         onChange={handlePaymentInputChange}
//                         placeholder="e.g., 0712345678"
//                         className={
//                           paymentErrors.mpesa_phone_number ? 'error' : ''
//                         }
//                       />
//                       {paymentErrors.mpesa_phone_number && (
//                         <span className="error-message">
//                           {paymentErrors.mpesa_phone_number}
//                         </span>
//                       )}
//                       <small className="hint">
//                         Must match the phone registered with M-Pesa.
//                       </small>
//                     </div>
//                   )}

//                   {paymentDetails.payment_method === 'bank' && (
//                     <div className="bank-fields">
//                       <div className="field">
//                         <label>
//                           Bank Name <span className="required">*</span>
//                         </label>
//                         <input
//                           type="text"
//                           name="bank_name"
//                           value={paymentDetails.bank_name}
//                           onChange={handlePaymentInputChange}
//                           placeholder="e.g., KCB, Equity, Co-operative"
//                           className={paymentErrors.bank_name ? 'error' : ''}
//                         />
//                         {paymentErrors.bank_name && (
//                           <span className="error-message">
//                             {paymentErrors.bank_name}
//                           </span>
//                         )}
//                       </div>
//                       <div className="field">
//                         <label>
//                           Account Name <span className="required">*</span>
//                         </label>
//                         <input
//                           type="text"
//                           name="bank_account_name"
//                           value={paymentDetails.bank_account_name}
//                           onChange={handlePaymentInputChange}
//                           placeholder="Full name on the bank account"
//                           className={
//                             paymentErrors.bank_account_name ? 'error' : ''
//                           }
//                         />
//                         {paymentErrors.bank_account_name && (
//                           <span className="error-message">
//                             {paymentErrors.bank_account_name}
//                           </span>
//                         )}
//                       </div>
//                       <div className="field">
//                         <label>
//                           Account Number <span className="required">*</span>
//                         </label>
//                         <input
//                           type="text"
//                           name="bank_account_number"
//                           value={paymentDetails.bank_account_number}
//                           onChange={handlePaymentInputChange}
//                           placeholder="Your bank account number"
//                           className={
//                             paymentErrors.bank_account_number ? 'error' : ''
//                           }
//                         />
//                         {paymentErrors.bank_account_number && (
//                           <span className="error-message">
//                             {paymentErrors.bank_account_number}
//                           </span>
//                         )}
//                       </div>
//                       <div className="field">
//                         <label>Bank Branch (Optional)</label>
//                         <input
//                           type="text"
//                           name="bank_branch"
//                           value={paymentDetails.bank_branch}
//                           onChange={handlePaymentInputChange}
//                           placeholder="e.g., Nairobi, Mombasa Road"
//                         />
//                       </div>
//                     </div>
//                   )}

//                   <div className="panel-actions">
//                     <button
//                       type="button"
//                       className="btn-ghost"
//                       onClick={cancelPaymentEdit}
//                       disabled={isPaymentLoading}
//                     >
//                       <FaTimes /> Cancel
//                     </button>
//                     <button
//                       type="submit"
//                       className="btn-craft"
//                       disabled={isPaymentLoading}
//                     >
//                       {isPaymentLoading ? (
//                         'Saving…'
//                       ) : (
//                         <>
//                           <FaCheck /> Save
//                         </>
//                       )}
//                     </button>
//                   </div>
//                 </Form>
//               )}
//             </div>
//           )}

//           {/* ================= LEGACY ================= */}
//           {activeTab === 'legacy' && (
//             <div className="panel-body">
//               <div className="legacy-meter">
//                 <div className="meter-row">
//                   <span className="meter-label">Legacy slots used</span>
//                   <span className="meter-count">
//                     <strong>{legacyCount}</strong> / {maxLegacyProjects}
//                   </span>
//                 </div>
//                 <div className="meter-track">
//                   <div
//                     className="meter-fill"
//                     style={{
//                       width: `${(legacyCount / maxLegacyProjects) * 100}%`,
//                     }}
//                   />
//                 </div>
//                 <span className="meter-hint">
//                   {remainingLegacySlots} slot
//                   {remainingLegacySlots !== 1 ? 's' : ''} remaining
//                 </span>
//               </div>

//               <Form onSubmit={saveLegacyProject} className="legacy-form">
//                 <div className="form-row">
//                   <div className="field">
//                     <label>
//                       <FaEdit /> Project Title
//                     </label>
//                     <input
//                       type="text"
//                       name="title"
//                       value={legacyForm.title}
//                       onChange={handleLegacyChange}
//                       placeholder="e.g., Custom Oak Dining Table"
//                       required
//                     />
//                     <small className="hint">
//                       Give it a name a client would remember.
//                     </small>
//                   </div>

//                   <div className="field">
//                     <label>
//                       <FaStar /> Your Rating
//                     </label>
//                     <div className="rating-selector">
//                       {[1, 2, 3, 4, 5].map((star) => (
//                         <button
//                           key={star}
//                           type="button"
//                           className={`rating-star-btn ${legacyForm.rating >= star ? 'selected' : ''}`}
//                           onClick={() =>
//                             setLegacyForm((prev) => ({ ...prev, rating: star }))
//                           }
//                         >
//                           <FaStar />
//                         </button>
//                       ))}
//                       <span className="rating-value">
//                         ({legacyForm.rating}/5)
//                       </span>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="field">
//                   <label>
//                     <FaEdit /> Project Description
//                   </label>
//                   <textarea
//                     name="description"
//                     rows={4}
//                     value={legacyForm.description}
//                     onChange={handleLegacyChange}
//                     placeholder="Materials used, challenges overcome, client requirements…"
//                     required
//                   />
//                   <div className="description-counter">
//                     <span>{legacyForm.description.length}</span>/500 characters
//                   </div>
//                 </div>

//                 <div className="field">
//                   <label>
//                     <FaCamera /> Project Images
//                   </label>
//                   <div
//                     className="upload-dropzone"
//                     onClick={() =>
//                       document.getElementById('legacyImageInput').click()
//                     }
//                   >
//                     {legacyForm.images.length > 0 ? (
//                       <div className="upload-preview">
//                         <span className="upload-count">
//                           {legacyForm.images.length} selected
//                         </span>
//                         <div className="upload-grid">
//                           {Array.from(legacyForm.images)
//                             .slice(0, 4)
//                             .map((file, i) => (
//                               <div key={i} className="upload-thumb">
//                                 <img
//                                   src={URL.createObjectURL(file)}
//                                   alt={`Preview ${i + 1}`}
//                                 />
//                                 {i === 3 && legacyForm.images.length > 4 && (
//                                   <div className="upload-more">
//                                     +{legacyForm.images.length - 4}
//                                   </div>
//                                 )}
//                               </div>
//                             ))}
//                         </div>
//                       </div>
//                     ) : (
//                       <div className="upload-empty">
//                         <FaImage className="upload-empty-icon" />
//                         <strong>Drop images or click to browse</strong>
//                         <span>JPG, PNG, WEBP · up to 5MB each</span>
//                       </div>
//                     )}
//                     <input
//                       type="file"
//                       id="legacyImageInput"
//                       name="images"
//                       multiple
//                       onChange={handleLegacyChange}
//                       accept="image/*"
//                       style={{ display: 'none' }}
//                     />
//                   </div>
//                 </div>

//                 <div className="panel-actions">
//                   {remainingLegacySlots <= 0 && (
//                     <div className="inline-warn">
//                       <FaExclamationTriangle /> You've used all{' '}
//                       {maxLegacyProjects} legacy slots.
//                     </div>
//                   )}
//                   <button
//                     type="submit"
//                     className="btn-craft"
//                     disabled={isLoading || remainingLegacySlots <= 0}
//                   >
//                     {isLoading ? (
//                       'Adding…'
//                     ) : (
//                       <>
//                         <FaPlus /> Add to Gallery
//                       </>
//                     )}
//                   </button>
//                 </div>
//               </Form>
//             </div>
//           )}

//           {/* ================= PORTFOLIO ================= */}
//           {activeTab === 'portfolio' && (
//             <div className="panel-body">
//               <div className="gallery-note">
//                 <FaInfoCircle />
//                 <div>
//                   <strong>Legacy work:</strong> these are projects you did
//                   outside the platform. They're perfect for showing range before
//                   you have platform reviews.
//                 </div>
//               </div>

//               {portfolio.length > 0 ? (
//                 <div className="gallery-wall">
//                   {portfolio.map((item) => (
//                     <figure className="gallery-piece" key={item.id}>
//                       <div className="piece-frame">
//                         {item.images && item.images.length > 0 ? (
//                           <Carousel
//                             variant="dark"
//                             indicators={item.images.length > 1}
//                             controls={item.images.length > 1}
//                             interval={null}
//                           >
//                             {item.images.map((image, index) => (
//                               <Carousel.Item key={index}>
//                                 <img
//                                   className="d-block w-100"
//                                   src={image.image}
//                                   alt={`${item.title} — ${index + 1}`}
//                                 />
//                               </Carousel.Item>
//                             ))}
//                           </Carousel>
//                         ) : (
//                           <div className="piece-empty">
//                             <FaImage />
//                             <span>No images</span>
//                           </div>
//                         )}
//                       </div>
//                       <figcaption className="piece-caption">
//                         <div className="piece-title-row">
//                           <h5>{item.title}</h5>
//                           {item.rating && (
//                             <span className="piece-rating">
//                               <FaStar /> {item.rating}
//                             </span>
//                           )}
//                         </div>
//                         <p>{item.description || 'No description provided.'}</p>
//                         <div className="piece-signature">
//                           <span className="sig-line" />
//                           <span className="sig-text">Workshop piece</span>
//                         </div>
//                       </figcaption>
//                     </figure>
//                   ))}
//                 </div>
//               ) : (
//                 <div className="empty-gallery">
//                   <div className="empty-gallery-icon">
//                     <FaImage />
//                   </div>
//                   <h5>Your gallery is empty</h5>
//                   <p>
//                     Add your first legacy piece and let clients see what you're
//                     capable of.
//                   </p>
//                   {remainingLegacySlots > 0 && (
//                     <button
//                       className="btn-craft"
//                       onClick={() => setActiveTab('legacy')}
//                     >
//                       <FaPlus /> Add First Piece
//                     </button>
//                   )}
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Crop Modal (unchanged) */}
//       <Modal
//         show={showCropModal}
//         onHide={cancelCrop}
//         size="lg"
//         centered
//         backdrop="static"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>
//             <FaCrop className="me-2" /> Crop Avatar Image
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="crop-container" style={{ textAlign: 'center' }}>
//             {selectedImage && (
//               <ReactCrop
//                 crop={crop}
//                 onChange={(c) => setCrop(c)}
//                 onComplete={onCropComplete}
//                 aspect={1}
//                 circularCrop
//                 className="react-crop"
//                 style={{ maxHeight: '500px' }}
//               >
//                 <img
//                   ref={imgRef}
//                   src={selectedImage}
//                   alt="Crop preview"
//                   style={{ maxWidth: '100%' }}
//                   onLoad={() => {
//                     const img = imgRef.current;
//                     if (img) {
//                       const { width, height } = img;
//                       const size = Math.min(width, height) * 0.8;
//                       setCrop({
//                         unit: 'px',
//                         width: size,
//                         height: size,
//                         x: (width - size) / 2,
//                         y: (height - size) / 2,
//                       });
//                     }
//                   }}
//                 />
//               </ReactCrop>
//             )}
//             <div className="mt-3 text-muted small">
//               <FaCamera className="me-1" /> Drag the corners to select the area
//               you want to keep. The image will be cropped to a perfect square.
//             </div>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={cancelCrop}>
//             <FaTimesCircle /> Cancel
//           </Button>
//           <Button variant="primary" onClick={applyCrop} className="crop-apply">
//             <FaCrop /> Apply Crop
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// };

// export default withAuth(ArtisanProfile, 'artisan');

// ArtisanProfile.jsx — Workshop Dashboard redesign
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../../components/layout/Sidebar';
import './artisanprofile.scss';
import withAuth from '../../auth/WithAuth';
import defaultAvatar from '../../../assets/DefaultProfile.png';
import {
  FaUser,
  FaEnvelope,
  FaPhone,
  FaCamera,
  FaCheck,
  FaExclamationTriangle,
  FaEdit,
  FaTimes,
  FaImage,
  FaStar,
  FaAward,
  FaPlus,
  FaTrash,
  FaArrowRight,
  FaCrop,
  FaTimesCircle,
  FaInfoCircle,
  FaLocationArrow,
  FaWallet,
  FaMobileAlt,
  FaUniversity,
  FaLock,
  FaEye,
  FaEyeSlash,
} from 'react-icons/fa';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import Carousel from 'react-bootstrap/Carousel';
import Modal from 'react-bootstrap/Modal';
import { serverUrlAuth } from '../../../serverUrl';
import { toast } from 'react-toastify';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

const ArtisanProfile = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('profile');
  const [profile, setProfile] = useState({
    name: '',
    email: '',
    phone: '',
    avatar: defaultAvatar,
    location: '',
    experience_years: 0,
    rating: 0,
    completed_projects: 0,
  });
  const [editable, setEditable] = useState(false);
  const [alerts, setAlerts] = useState({
    profile: '',
    legacy: '',
    portfolio: '',
    payment: '',
  });
  const [isLoading, setIsLoading] = useState(false);

  const [portfolioData, setPortfolioData] = useState(null);
  const [portfolio, setPortfolio] = useState([]);
  const [artisanProfile, setArtisanProfile] = useState([]);
  const [legacyForm, setLegacyForm] = useState({
    title: '',
    description: '',
    rating: 1,
    images: [],
  });
  const fileInputRef = useRef(null);

  const [paymentDetails, setPaymentDetails] = useState({
    payment_method: '',
    mpesa_phone_number: '',
    mpesa_name: '',
    bank_name: '',
    bank_account_name: '',
    bank_account_number: '',
    bank_branch: '',
  });
  const [paymentViewPassword, setPaymentViewPassword] = useState('');
  const [showPaymentPassword, setShowPaymentPassword] = useState(false);
  const [isPaymentVerified, setIsPaymentVerified] = useState(false);
  const [isPaymentLoading, setIsPaymentLoading] = useState(false);
  const [paymentEditable, setPaymentEditable] = useState(false);
  const [paymentErrors, setPaymentErrors] = useState({});
  const [isVerifying, setIsVerifying] = useState(false);

  const [showCropModal, setShowCropModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [crop, setCrop] = useState({
    unit: '%',
    width: 80,
    height: 80,
    x: 10,
    y: 10,
  });
  const [completedCrop, setCompletedCrop] = useState(null);
  const [croppedImageUrl, setCroppedImageUrl] = useState(null);
  const [croppedImageFile, setCroppedImageFile] = useState(null);
  const imgRef = useRef(null);

  const fetchProfile = async () => {
    try {
      const res = await serverUrlAuth.get('users/profile/');
      const data = res.data;
      setProfile((prev) => ({
        ...prev,
        name: data.full_name,
        email: data.email,
        phone: data.phone_number || '',
        avatar: data.profile_picture || defaultAvatar,
      }));
    } catch (error) {
      console.error('Failed to fetch profile:', error);
    }
  };

  const fetchArtisanProfile = async () => {
    try {
      const response = await serverUrlAuth.get('users/artisan/profile/');
      setArtisanProfile(response.data);
      if (response.data) {
        setProfile((prev) => ({
          ...prev,
          location: response.data.location || '',
        }));
      }
    } catch (error) {
      console.error('Failed to fetch artisan profile:', error);
    }
  };

  useEffect(() => {
    fetchProfile();
    fetchArtisanProfile();
  }, []);

  const loadPortfolio = async () => {
    try {
      const res = await serverUrlAuth.get('portfolio/artisan-portfolio/');
      const data = res.data;
      setPortfolioData(data);
      setPortfolio(data.portfolio_items || []);
      setProfile((prev) => ({
        ...prev,
        experience_years: data.years_of_experience || 0,
        rating: data.client_rating || 0,
        completed_projects: data.projects_completed || 0,
      }));
    } catch (error) {
      console.error('Failed to load portfolio:', error);
      showAlert('portfolio', 'Failed to load portfolio', 'error');
    }
  };

  useEffect(() => {
    loadPortfolio();
  }, []);

  const showAlert = (type, message, variant = 'success') => {
    setAlerts((prev) => ({ ...prev, [type]: { message, variant } }));
    setTimeout(() => setAlerts((prev) => ({ ...prev, [type]: '' })), 5000);
  };

  const handleProfileChange = (e) => {
    const { name, value } = e.target;
    setProfile((prev) => ({ ...prev, [name]: value }));
  };

  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        showAlert('profile', 'Please select a valid image', 'error');
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        showAlert('profile', 'Image must be less than 5MB', 'error');
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        setSelectedImage(reader.result);
        setShowCropModal(true);
        setCrop({ unit: '%', width: 80, height: 80, x: 10, y: 10 });
        setCompletedCrop(null);
        setCroppedImageUrl(null);
        setCroppedImageFile(null);
      };
      reader.readAsDataURL(file);
      e.target.value = null;
    }
  };

  const triggerFileInput = () => editable && fileInputRef.current?.click();
  const onCropComplete = (crop) => setCompletedCrop(crop);

  const getCroppedImg = async () => {
    if (!imgRef.current || !completedCrop) return;
    try {
      const canvas = document.createElement('canvas');
      const image = imgRef.current;
      const crop = completedCrop;
      const scaleX = image.naturalWidth / image.width;
      const scaleY = image.naturalHeight / image.height;
      canvas.width = crop.width * scaleX;
      canvas.height = crop.height * scaleY;
      const ctx = canvas.getContext('2d');
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width * scaleX,
        crop.height * scaleY,
      );
      return new Promise((resolve) => {
        canvas.toBlob(
          (blob) => {
            if (blob) {
              const url = URL.createObjectURL(blob);
              const file = new File([blob], 'avatar.jpg', {
                type: 'image/jpeg',
              });
              resolve({ url, file });
            }
          },
          'image/jpeg',
          0.95,
        );
      });
    } catch (error) {
      console.error('Error cropping image:', error);
      showAlert('profile', 'Failed to crop image', 'error');
    }
  };

  const applyCrop = async () => {
    if (!completedCrop) {
      showAlert('profile', 'Please crop the image first', 'error');
      return;
    }
    try {
      const result = await getCroppedImg();
      if (result) {
        setCroppedImageUrl(result.url);
        setCroppedImageFile(result.file);
        setProfile((prev) => ({ ...prev, avatar: result.url }));
        showAlert('profile', 'Avatar cropped successfully!', 'success');
        setShowCropModal(false);
      }
    } catch (error) {
      console.error('Error applying crop:', error);
      showAlert('profile', 'Failed to apply crop', 'error');
    }
  };

  const cancelCrop = () => {
    setShowCropModal(false);
    setSelectedImage(null);
    setCroppedImageUrl(null);
    setCroppedImageFile(null);
    setCompletedCrop(null);
  };

  const toggleEdit = () => {
    setEditable(true);
  };

  const cancelEdit = () => {
    setEditable(false);
    setCroppedImageUrl(null);
    setCroppedImageFile(null);
    // Refresh to reset any unsaved changes
    fetchProfile();
    fetchArtisanProfile();
  };

  const saveProfile = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append('full_name', profile.name);
      formData.append('phone_number', profile.phone);
      formData.append('location', profile.location);
      if (croppedImageFile)
        formData.append('profile_picture', croppedImageFile);
      else if (fileInputRef.current?.files[0])
        formData.append('profile_picture', fileInputRef.current.files[0]);
      const res = await serverUrlAuth.patch('users/profile/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setProfile((prev) => ({
        ...prev,
        avatar: res.data.profile_picture || prev.avatar,
      }));
      setCroppedImageUrl(null);
      setCroppedImageFile(null);
      showAlert('profile', 'Profile updated successfully!', 'success');
      setEditable(false);
    } catch (error) {
      console.error(error);
      showAlert('profile', 'Failed to update profile', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    return () => {
      if (croppedImageUrl) URL.revokeObjectURL(croppedImageUrl);
    };
  }, [croppedImageUrl]);

  const handleLegacyChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'images')
      setLegacyForm((prev) => ({ ...prev, images: files }));
    else setLegacyForm((prev) => ({ ...prev, [name]: value }));
  };

  const saveLegacyProject = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append('title', legacyForm.title);
      formData.append('description', legacyForm.description);
      formData.append('rating', legacyForm.rating);
      for (let i = 0; i < legacyForm.images.length; i++)
        formData.append('images', legacyForm.images[i]);
      const response = await serverUrlAuth.post(
        'portfolio/artisan-portfolio/legacy/create/',
        formData,
      );
      toast.success(
        response.data.detail || 'Legacy project added successfully!',
      );
      setLegacyForm({ title: '', description: '', rating: 1, images: [] });
      await loadPortfolio();
      if (response.data.remaining_slots > 0)
        toast.info(
          `You have ${response.data.remaining_slots} more legacy project slots remaining.`,
        );
      else toast.info('You have reached the maximum of 5 legacy projects.');
    } catch (err) {
      console.error(err);
      const msg =
        err.response?.data?.detail ||
        'Failed to add legacy project. Maybe you reached the 5-project limit.';
      showAlert('legacy', msg, 'error');
    } finally {
      setIsLoading(false);
    }
  };

  const verifyPaymentPassword = async (e) => {
    e.preventDefault();
    if (!paymentViewPassword) {
      toast.error('Please enter your password');
      return;
    }
    setIsVerifying(true);
    try {
      const response = await serverUrlAuth.post(
        'users/payment-details/verify/',
        { password: paymentViewPassword },
      );
      if (response.data.status) {
        setIsPaymentVerified(true);
        const details = response.data.payment_details;
        setPaymentDetails({
          payment_method: details.payment_method || 'mpesa',
          mpesa_phone_number: details.mpesa_phone_number || '',
          mpesa_name: details.mpesa_name || '',
          bank_name: details.bank_name || '',
          bank_account_name: details.bank_account_name || '',
          bank_account_number: details.bank_account_number || '',
          bank_branch: details.bank_branch || '',
        });
        toast.success(
          response.data.message || 'Password verified successfully!',
        );
        setPaymentViewPassword('');
        setPaymentErrors({});
      }
    } catch (error) {
      console.error('Password verification failed:', error);
      if (error.response?.data) {
        toast.error(error.response.data.message || 'Invalid password');
        setPaymentErrors({
          password: error.response.data.message || 'Invalid password',
        });
      } else toast.error('Failed to verify password');
      setPaymentViewPassword('');
    } finally {
      setIsVerifying(false);
    }
  };

  const maskPhoneNumber = (phone) => {
    if (!phone) return 'Not set';
    if (phone.length <= 4) return phone;
    return `${phone.slice(0, 4)}******${phone.slice(-2)}`;
  };
  const maskAccountNumber = (account) => {
    if (!account) return 'Not set';
    if (account.length <= 4) return account;
    return `${account.slice(0, 4)}******`;
  };
  const maskAccountName = (name) => {
    if (!name) return 'Not set';
    if (name.length <= 3) return name;
    return name.slice(0, 3) + name.slice(3).replace(/./g, '*');
  };
  const maskBankName = (name) => {
    if (!name) return 'Not set';
    if (name.length <= 3) return name;
    return name.slice(0, 3) + name.slice(3).replace(/./g, '*');
  };

  const enablePaymentEdit = () => {
    setPaymentEditable(true);
    setPaymentErrors({});
  };
  const cancelPaymentEdit = () => {
    setPaymentEditable(false);
    setPaymentErrors({});
    setIsPaymentVerified(false);
    setPaymentViewPassword('');
    toast.info('Please re-verify your password to view payment details');
  };
  const handlePaymentInputChange = (e) => {
    const { name, value } = e.target;
    setPaymentDetails((prev) => ({ ...prev, [name]: value }));
    if (paymentErrors[name])
      setPaymentErrors((prev) => ({ ...prev, [name]: '' }));
  };
  const handlePaymentMethodChange = (method) => {
    setPaymentDetails((prev) => ({ ...prev, payment_method: method }));
    setPaymentErrors({});
  };

  const validatePaymentDetails = () => {
    const errors = {};
    if (paymentDetails.payment_method === 'mpesa') {
      if (!paymentDetails.mpesa_phone_number)
        errors.mpesa_phone_number = 'Phone number is required';
      else {
        const phone = paymentDetails.mpesa_phone_number.replace(/\s/g, '');
        const phoneRegex = /^(?:\+254|0)?[17]\d{8}$/;
        if (!phoneRegex.test(phone))
          errors.mpesa_phone_number =
            'Please enter a valid Kenyan phone number (e.g., 0712345678)';
      }
    } else if (paymentDetails.payment_method === 'bank') {
      if (!paymentDetails.bank_name) errors.bank_name = 'Bank name is required';
      if (!paymentDetails.bank_account_name)
        errors.bank_account_name = 'Account name is required';
      if (!paymentDetails.bank_account_number)
        errors.bank_account_number = 'Account number is required';
    }
    return errors;
  };

  const savePaymentDetails = async (e) => {
    e.preventDefault();
    const errors = validatePaymentDetails();
    if (Object.keys(errors).length > 0) {
      setPaymentErrors(errors);
      return;
    }
    setIsPaymentLoading(true);
    try {
      const payload = {
        payment_method: paymentDetails.payment_method,
        mpesa_phone_number: paymentDetails.mpesa_phone_number,
        bank_name: paymentDetails.bank_name,
        bank_account_name: paymentDetails.bank_account_name,
        bank_account_number: paymentDetails.bank_account_number,
        bank_branch: paymentDetails.bank_branch,
      };
      const response = await serverUrlAuth.patch(
        'users/artisan/profile/',
        payload,
      );
      toast.success(
        response.data.message || 'Payment details updated successfully!',
      );
      setPaymentEditable(false);
      setPaymentErrors({});
      setIsPaymentVerified(false);
      setPaymentViewPassword('');
      toast.info(
        'Please re-verify your password to view updated payment details',
      );
    } catch (error) {
      console.error('Error saving payment details:', error);
      if (error.response?.data)
        toast.error(
          error.response.data.message || 'Failed to save payment details',
        );
      else toast.error('Failed to save payment details');
    } finally {
      setIsPaymentLoading(false);
    }
  };

  const handleDeleteAccountClick = () => navigate('/delete-account');

  const legacyCount = portfolioData?.legacy_projects_count || 0;
  const maxLegacyProjects = 5;
  const remainingLegacySlots = Math.max(0, maxLegacyProjects - legacyCount);

  // "Stations" = tabs reimagined as workshop tools
  const stations = [
    { id: 'profile', icon: <FaUser />, label: 'Identity', sub: 'Your details' },
    {
      id: 'payment',
      icon: <FaWallet />,
      label: 'Payment details',
      sub: 'Get paid',
    },
    {
      id: 'portfolio',
      icon: <FaImage />,
      label: 'Portfolio',
      sub: 'Your work',
    },
    ...(remainingLegacySlots > 0
      ? [
          {
            id: 'legacy',
            icon: <FaPlus />,
            label: 'Add Legacy',
            sub: `${remainingLegacySlots} left`,
            badge: remainingLegacySlots,
          },
        ]
      : []),
  ];

  return (
    <>
      <Sidebar />
      <div className="modern-dashboard workshop-profile">
        {/* ============================================================
            WORKSHOP IDENTITY HERO — avatar bleeds out of the banner
           ============================================================ */}
        <section className="workshop-hero">
          <div className="hero-pattern"></div>
          <span className="hero-circle hero-circle-1"></span>
          <span className="hero-circle hero-circle-2"></span>
          <span className="hero-circle hero-circle-3"></span>
          <span className="hero-circle hero-circle-4"></span>
          <span className="hero-circle hero-circle-5"></span>
          <span className="hero-circle hero-circle-6"></span>
          <span className="hero-circle hero-circle-7"></span>
          <span className="hero-circle hero-circle-8"></span>
          <span className="hero-circle hero-circle-9"></span>
          <span className="hero-circle hero-circle-10"></span>

          <div className="hero-inner">
            <div className="identity-avatar">
              <img src={profile.avatar} alt={profile.name || 'Artisan'} />
              {editable && (
                <button
                  type="button"
                  className="avatar-edit-btn"
                  onClick={triggerFileInput}
                  title="Change profile photo"
                >
                  <FaCamera />
                </button>
              )}
              <input
                type="file"
                ref={fileInputRef}
                onChange={handleAvatarChange}
                accept="image/*"
                style={{ display: 'none' }}
              />
            </div>

            <div className="identity-text">
              <div className="identity-eyebrow">
                <span className="dot" /> Artisan Workshop
              </div>
              <h1 className="identity-name">{profile.name || 'Your Name'}</h1>
              <div className="identity-meta">
                {profile.location && (
                  <span className="meta-chip">
                    <FaLocationArrow /> {profile.location}
                  </span>
                )}
                {profile.rating > 0 && (
                  <span className="meta-chip rating">
                    <FaStar /> {profile.rating} rating
                  </span>
                )}
                <span className="meta-chip">
                  <FaAward /> {profile.experience_years} yrs experience
                </span>
              </div>
            </div>
          </div>

          <div className="stat-floater">
            <div className="float-pill">
              <span className="pill-value">{profile.completed_projects}</span>
              <span className="pill-label">Projects Done</span>
            </div>
            <div className="float-pill">
              <span className="pill-value">{portfolio.length}</span>
              <span className="pill-label">Portfolio Pieces</span>
            </div>
            <div className="float-pill">
              <span className="pill-value">{profile.rating}</span>
              <span className="pill-label">Client Rating</span>
            </div>
            <div className="float-pill">
              <span className="pill-value">{profile.experience_years}</span>
              <span className="pill-label">Years Crafting</span>
            </div>
          </div>
        </section>

        {/* ============================================================
            HORIZONTAL STATION TABS
           ============================================================ */}
        <nav className="station-nav" aria-label="Workshop sections">
          {stations.map((s) => (
            <button
              key={s.id}
              className={`station ${activeTab === s.id ? 'active' : ''}`}
              onClick={() => {
                setActiveTab(s.id);
                if (s.id === 'payment') {
                  setIsPaymentVerified(false);
                  setPaymentEditable(false);
                  setPaymentViewPassword('');
                  setPaymentErrors({});
                }
                if (s.id !== 'profile') {
                  setEditable(false);
                }
              }}
            >
              <span className="station-icon">{s.icon}</span>
              <span className="station-text">
                <span className="station-label">{s.label}</span>
                <span className="station-sub">{s.sub}</span>
              </span>
              {s.badge && <span className="station-badge">{s.badge}</span>}
            </button>
          ))}

          <button className="station danger" onClick={handleDeleteAccountClick}>
            <span className="station-icon">
              <FaTrash />
            </span>
            <span className="station-text">
              <span className="station-label">Danger Zone</span>
              <span className="station-sub">Delete account</span>
            </span>
            <FaArrowRight className="station-arrow" />
          </button>
        </nav>

        {/* ============================================================
            WORKSHOP PANEL — content morphs per station
           ============================================================ */}
        <div className="workshop-panel">
          {/* Alerts */}
          {['profile', 'legacy', 'portfolio', 'payment'].map(
            (type) =>
              alerts[type] && (
                <Alert
                  key={type}
                  variant={alerts[type].variant}
                  className="alert-custom"
                >
                  {alerts[type].variant === 'success' ? (
                    <FaCheck />
                  ) : (
                    <FaExclamationTriangle />
                  )}
                  {alerts[type].message}
                </Alert>
              ),
          )}

          <span className="corner tl" />
          <span className="corner tr" />
          <span className="corner bl" />
          <span className="corner br" />

          <header className="panel-ribbon">
            <span className="ribbon-label">
              {activeTab === 'profile' && 'Identity Station'}
              {activeTab === 'payment' && 'Payments Station'}
              {activeTab === 'legacy' && 'Add Legacy Piece'}
              {activeTab === 'portfolio' && 'Gallery Wall'}
            </span>
            <span className="ribbon-line" />
          </header>

          {/* ================= PROFILE ================= */}
          {activeTab === 'profile' && (
            <Form onSubmit={saveProfile} className="panel-body">
              <div className="split-panel">
                <aside className="split-aside">
                  <div className="aside-badge">
                    <FaUser />
                  </div>
                  <h4 className="aside-title">Your workshop identity</h4>
                  <p className="aside-text">
                    This is what clients see first. Keep it sharp — a clear
                    name, a reachable phone, and a real location build trust
                    before you even send a proposal.
                  </p>
                  <div className="aside-hint">
                    <FaInfoCircle />
                    <span>Email can't be changed here.</span>
                  </div>
                </aside>

                <div className={`split-main ${editable ? 'is-editing' : ''}`}>
                  <div className="field-grid">
                    <div className="field">
                      <label>
                        <FaUser /> Full Name
                      </label>
                      <Form.Control
                        type="text"
                        name="name"
                        value={profile.name}
                        onChange={handleProfileChange}
                        disabled={!editable}
                        required
                      />
                    </div>
                    <div className="field">
                      <label>
                        <FaEnvelope /> Email
                      </label>
                      <Form.Control
                        type="email"
                        value={profile.email}
                        disabled
                      />
                    </div>
                    <div className="field">
                      <label>
                        <FaPhone /> Phone
                      </label>
                      <Form.Control
                        type="tel"
                        name="phone"
                        value={profile.phone}
                        onChange={handleProfileChange}
                        disabled={!editable}
                      />
                    </div>
                    <div className="field">
                      <label>
                        <FaLocationArrow /> Location
                      </label>
                      <Form.Control
                        type="text"
                        name="location"
                        value={artisanProfile.location || ''}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="panel-actions">
                    {' '}
                    {!editable && (
                      <button
                        type="button"
                        className="btn-craft"
                        onClick={() => setEditable(true)}
                      >
                        <FaEdit /> Edit Identity
                      </button>
                    )}
                    {editable && (
                      <>
                        <button
                          type="submit"
                          className="btn-craft"
                          disabled={isLoading}
                        >
                          {isLoading ? (
                            'Saving…'
                          ) : (
                            <>
                              <FaCheck /> Save Changes
                            </>
                          )}
                        </button>
                        <button
                          type="button"
                          className="btn-ghost"
                          onClick={cancelEdit}
                        >
                          <FaTimes /> Cancel
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </Form>
          )}

          {/* ================= PAYMENT ================= */}
          {activeTab === 'payment' && (
            <div className="panel-body">
              {!isPaymentVerified ? (
                <div className="vault-lock">
                  <div className="vault-ring">
                    <FaLock />
                  </div>
                  <h4 className="vault-title">Vault Access Required</h4>
                  <p className="vault-text">
                    Your payment details are locked. Enter your password to
                    unlock them — this keeps your financial info safe even if
                    someone else has your device.
                  </p>
                  <Form onSubmit={verifyPaymentPassword} className="vault-form">
                    <div className="vault-input">
                      <Form.Control
                        type={showPaymentPassword ? 'text' : 'password'}
                        placeholder="Enter your password"
                        value={paymentViewPassword}
                        onChange={(e) => {
                          setPaymentViewPassword(e.target.value);
                          setPaymentErrors({});
                        }}
                        className={paymentErrors.password ? 'error' : ''}
                        disabled={isVerifying}
                        autoFocus
                      />
                      <button
                        type="button"
                        className="vault-toggle"
                        onClick={() =>
                          setShowPaymentPassword(!showPaymentPassword)
                        }
                        tabIndex={-1}
                      >
                        {showPaymentPassword ? <FaEyeSlash /> : <FaEye />}
                      </button>
                    </div>
                    <button
                      type="submit"
                      className="btn-craft"
                      disabled={isVerifying || !paymentViewPassword}
                    >
                      {isVerifying ? (
                        <>Verifying…</>
                      ) : (
                        <>
                          <FaLock /> Unlock
                        </>
                      )}
                    </button>
                  </Form>
                  {paymentErrors.password && (
                    <span className="error-message">
                      {paymentErrors.password}
                    </span>
                  )}
                </div>
              ) : !paymentEditable ? (
                <div className="vault-view">
                  <div className="vault-method">
                    <div className="vault-method-icon">
                      {paymentDetails.payment_method === 'mpesa' ? (
                        <FaMobileAlt />
                      ) : (
                        <FaUniversity />
                      )}
                    </div>
                    <div>
                      <span className="vault-method-label">Payment Method</span>
                      <span className="vault-method-value">
                        {paymentDetails.payment_method === 'mpesa'
                          ? 'M-Pesa'
                          : 'Bank Transfer'}
                      </span>
                    </div>
                  </div>

                  <div className="vault-fields">
                    {paymentDetails.payment_method === 'mpesa' ? (
                      <>
                        <div className="vault-field">
                          <span className="vault-label">Phone Number</span>
                          <span className="vault-value masked">
                            {maskPhoneNumber(paymentDetails.mpesa_phone_number)}
                          </span>
                        </div>
                        {paymentDetails.mpesa_name && (
                          <div className="vault-field">
                            <span className="vault-label">Account Name</span>
                            <span className="vault-value">
                              {paymentDetails.mpesa_name}
                            </span>
                          </div>
                        )}
                      </>
                    ) : (
                      <>
                        <div className="vault-field">
                          <span className="vault-label">Bank Name</span>
                          <span className="vault-value masked">
                            {maskBankName(paymentDetails.bank_name)}
                          </span>
                        </div>
                        <div className="vault-field">
                          <span className="vault-label">Account Name</span>
                          <span className="vault-value masked">
                            {maskAccountName(paymentDetails.bank_account_name)}
                          </span>
                        </div>
                        <div className="vault-field">
                          <span className="vault-label">Account Number</span>
                          <span className="vault-value masked">
                            {maskAccountNumber(
                              paymentDetails.bank_account_number,
                            )}
                          </span>
                        </div>
                        {paymentDetails.bank_branch && (
                          <div className="vault-field">
                            <span className="vault-label">Branch</span>
                            <span className="vault-value">
                              {paymentDetails.bank_branch}
                            </span>
                          </div>
                        )}
                      </>
                    )}
                  </div>

                  <div className="panel-actions">
                    <button
                      type="button"
                      className="btn-craft"
                      onClick={enablePaymentEdit}
                    >
                      <FaEdit /> Edit Payment Details
                    </button>
                  </div>
                </div>
              ) : (
                <Form onSubmit={savePaymentDetails} className="vault-form-edit">
                  <div className="vault-section">
                    <h5 className="vault-section-title">
                      Choose how you get paid
                    </h5>
                    <div className="vault-methods">
                      <button
                        type="button"
                        className={`vault-method-pick ${
                          paymentDetails.payment_method === 'mpesa'
                            ? 'active'
                            : ''
                        }`}
                        onClick={() => handlePaymentMethodChange('mpesa')}
                      >
                        <FaMobileAlt />
                        <div>
                          <strong>M-Pesa</strong>
                          <span>Send to your phone</span>
                        </div>
                        {paymentDetails.payment_method === 'mpesa' && (
                          <FaCheck className="pick-check" />
                        )}
                      </button>
                      <button
                        type="button"
                        className={`vault-method-pick ${
                          paymentDetails.payment_method === 'bank'
                            ? 'active'
                            : ''
                        }`}
                        onClick={() => handlePaymentMethodChange('bank')}
                      >
                        <FaUniversity />
                        <div>
                          <strong>Bank Transfer</strong>
                          <span>Direct to your bank</span>
                        </div>
                        {paymentDetails.payment_method === 'bank' && (
                          <FaCheck className="pick-check" />
                        )}
                      </button>
                    </div>
                  </div>

                  {paymentDetails.payment_method === 'mpesa' && (
                    <div className="field">
                      <label>
                        M-Pesa Phone Number <span className="required">*</span>
                      </label>
                      <input
                        type="tel"
                        name="mpesa_phone_number"
                        value={paymentDetails.mpesa_phone_number}
                        onChange={handlePaymentInputChange}
                        placeholder="e.g., 0712345678"
                        className={
                          paymentErrors.mpesa_phone_number ? 'error' : ''
                        }
                      />
                      {paymentErrors.mpesa_phone_number && (
                        <span className="error-message">
                          {paymentErrors.mpesa_phone_number}
                        </span>
                      )}
                      <small className="hint">
                        Must match the phone registered with M-Pesa.
                      </small>
                    </div>
                  )}

                  {paymentDetails.payment_method === 'bank' && (
                    <div className="bank-fields">
                      <div className="field">
                        <label>
                          Bank Name <span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          name="bank_name"
                          value={paymentDetails.bank_name}
                          onChange={handlePaymentInputChange}
                          placeholder="e.g., KCB, Equity, Co-operative"
                          className={paymentErrors.bank_name ? 'error' : ''}
                        />
                        {paymentErrors.bank_name && (
                          <span className="error-message">
                            {paymentErrors.bank_name}
                          </span>
                        )}
                      </div>
                      <div className="field">
                        <label>
                          Account Name <span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          name="bank_account_name"
                          value={paymentDetails.bank_account_name}
                          onChange={handlePaymentInputChange}
                          placeholder="Full name on the bank account"
                          className={
                            paymentErrors.bank_account_name ? 'error' : ''
                          }
                        />
                        {paymentErrors.bank_account_name && (
                          <span className="error-message">
                            {paymentErrors.bank_account_name}
                          </span>
                        )}
                      </div>
                      <div className="field">
                        <label>
                          Account Number <span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          name="bank_account_number"
                          value={paymentDetails.bank_account_number}
                          onChange={handlePaymentInputChange}
                          placeholder="Your bank account number"
                          className={
                            paymentErrors.bank_account_number ? 'error' : ''
                          }
                        />
                        {paymentErrors.bank_account_number && (
                          <span className="error-message">
                            {paymentErrors.bank_account_number}
                          </span>
                        )}
                      </div>
                      <div className="field">
                        <label>Bank Branch (Optional)</label>
                        <input
                          type="text"
                          name="bank_branch"
                          value={paymentDetails.bank_branch}
                          onChange={handlePaymentInputChange}
                          placeholder="e.g., Nairobi, Mombasa Road"
                        />
                      </div>
                    </div>
                  )}

                  <div className="panel-actions">
                    <button
                      type="button"
                      className="btn-ghost"
                      onClick={cancelPaymentEdit}
                      disabled={isPaymentLoading}
                    >
                      <FaTimes /> Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn-craft"
                      disabled={isPaymentLoading}
                    >
                      {isPaymentLoading ? (
                        'Saving…'
                      ) : (
                        <>
                          <FaCheck /> Save
                        </>
                      )}
                    </button>
                  </div>
                </Form>
              )}
            </div>
          )}

          {/* ================= LEGACY ================= */}
          {activeTab === 'legacy' && (
            <div className="panel-body">
              <div className="legacy-meter">
                <div className="meter-row">
                  <span className="meter-label">Legacy slots used</span>
                  <span className="meter-count">
                    <strong>{legacyCount}</strong> / {maxLegacyProjects}
                  </span>
                </div>
                <div className="meter-track">
                  <div
                    className="meter-fill"
                    style={{
                      width: `${(legacyCount / maxLegacyProjects) * 100}%`,
                    }}
                  />
                </div>
                <span className="meter-hint">
                  {remainingLegacySlots} slot
                  {remainingLegacySlots !== 1 ? 's' : ''} remaining
                </span>
              </div>

              <Form onSubmit={saveLegacyProject} className="legacy-form">
                <div className="form-row">
                  <div className="field">
                    <label>
                      <FaEdit /> Project Title
                    </label>
                    <input
                      type="text"
                      name="title"
                      value={legacyForm.title}
                      onChange={handleLegacyChange}
                      placeholder="e.g., Custom Oak Dining Table"
                      required
                    />
                    <small className="hint">
                      Give it a name a client would remember.
                    </small>
                  </div>

                  <div className="field">
                    <label>
                      <FaStar /> Your Rating
                    </label>
                    <div className="rating-selector">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <button
                          key={star}
                          type="button"
                          className={`rating-star-btn ${
                            legacyForm.rating >= star ? 'selected' : ''
                          }`}
                          onClick={() =>
                            setLegacyForm((prev) => ({
                              ...prev,
                              rating: star,
                            }))
                          }
                        >
                          <FaStar />
                        </button>
                      ))}
                      <span className="rating-value">
                        ({legacyForm.rating}/5)
                      </span>
                    </div>
                  </div>
                </div>

                <div className="field">
                  <label>
                    <FaEdit /> Project Description
                  </label>
                  <textarea
                    name="description"
                    rows={4}
                    value={legacyForm.description}
                    onChange={handleLegacyChange}
                    placeholder="Materials used, challenges overcome, client requirements…"
                    required
                  />
                  <div className="description-counter">
                    <span>{legacyForm.description.length}</span>/500 characters
                  </div>
                </div>

                <div className="field">
                  <label>
                    <FaCamera /> Project Images
                  </label>
                  <div
                    className="upload-dropzone"
                    onClick={() =>
                      document.getElementById('legacyImageInput').click()
                    }
                  >
                    {legacyForm.images.length > 0 ? (
                      <div className="upload-preview">
                        <span className="upload-count">
                          {legacyForm.images.length} selected
                        </span>
                        <div className="upload-grid">
                          {Array.from(legacyForm.images)
                            .slice(0, 4)
                            .map((file, i) => (
                              <div key={i} className="upload-thumb">
                                <img
                                  src={URL.createObjectURL(file)}
                                  alt={`Preview ${i + 1}`}
                                />
                                {i === 3 && legacyForm.images.length > 4 && (
                                  <div className="upload-more">
                                    +{legacyForm.images.length - 4}
                                  </div>
                                )}
                              </div>
                            ))}
                        </div>
                      </div>
                    ) : (
                      <div className="upload-empty">
                        <FaImage className="upload-empty-icon" />
                        <strong>Drop images or click to browse</strong>
                        <span>JPG, PNG, WEBP · up to 5MB each</span>
                      </div>
                    )}
                    <input
                      type="file"
                      id="legacyImageInput"
                      name="images"
                      multiple
                      onChange={handleLegacyChange}
                      accept="image/*"
                      style={{ display: 'none' }}
                    />
                  </div>
                </div>

                <div className="panel-actions">
                  {remainingLegacySlots <= 0 && (
                    <div className="inline-warn">
                      <FaExclamationTriangle /> You've used all{' '}
                      {maxLegacyProjects} legacy slots.
                    </div>
                  )}
                  <button
                    type="submit"
                    className="btn-craft"
                    disabled={isLoading || remainingLegacySlots <= 0}
                  >
                    {isLoading ? (
                      'Adding…'
                    ) : (
                      <>
                        <FaPlus /> Add to Gallery
                      </>
                    )}
                  </button>
                </div>
              </Form>
            </div>
          )}

          {/* ================= PORTFOLIO ================= */}
          {activeTab === 'portfolio' && (
            <div className="panel-body">
              <div className="gallery-note">
                <FaInfoCircle />
                <div>
                  <strong>Legacy work:</strong> these are projects you did
                  outside the platform. They're perfect for showing range before
                  you have platform reviews.
                </div>
              </div>

              {portfolio.length > 0 ? (
                <div className="gallery-wall">
                  {portfolio.map((item) => (
                    <figure className="gallery-piece" key={item.id}>
                      <div className="piece-frame">
                        {item.images && item.images.length > 0 ? (
                          <Carousel
                            variant="dark"
                            indicators={item.images.length > 1}
                            controls={item.images.length > 1}
                            interval={null}
                          >
                            {item.images.map((image, index) => (
                              <Carousel.Item key={index}>
                                <img
                                  className="d-block w-100"
                                  src={image.image}
                                  alt={`${item.title} — ${index + 1}`}
                                />
                              </Carousel.Item>
                            ))}
                          </Carousel>
                        ) : (
                          <div className="piece-empty">
                            <FaImage />
                            <span>No images</span>
                          </div>
                        )}
                      </div>
                      <figcaption className="piece-caption">
                        <div className="piece-title-row">
                          <h5>{item.title}</h5>
                          {item.rating && (
                            <span className="piece-rating">
                              <FaStar /> {item.rating}
                            </span>
                          )}
                        </div>
                        <p>{item.description || 'No description provided.'}</p>
                        <div className="piece-signature">
                          <span className="sig-line" />
                          <span className="sig-text">Workshop piece</span>
                        </div>
                      </figcaption>
                    </figure>
                  ))}
                </div>
              ) : (
                <div className="empty-gallery">
                  <div className="empty-gallery-icon">
                    <FaImage />
                  </div>
                  <h5>Your gallery is empty</h5>
                  <p>
                    Add your first legacy piece and let clients see what you're
                    capable of.
                  </p>
                  {remainingLegacySlots > 0 && (
                    <button
                      className="btn-craft"
                      onClick={() => setActiveTab('legacy')}
                    >
                      <FaPlus /> Add First Piece
                    </button>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Crop Modal */}
      <Modal
        show={showCropModal}
        onHide={cancelCrop}
        size="lg"
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FaCrop className="me-2" /> Crop Avatar Image
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="crop-container" style={{ textAlign: 'center' }}>
            {selectedImage && (
              <ReactCrop
                crop={crop}
                onChange={(c) => setCrop(c)}
                onComplete={onCropComplete}
                aspect={1}
                circularCrop
                className="react-crop"
                style={{ maxHeight: '500px' }}
              >
                <img
                  ref={imgRef}
                  src={selectedImage}
                  alt="Crop preview"
                  style={{ maxWidth: '100%' }}
                  onLoad={() => {
                    const img = imgRef.current;
                    if (img) {
                      const { width, height } = img;
                      const size = Math.min(width, height) * 0.8;
                      setCrop({
                        unit: 'px',
                        width: size,
                        height: size,
                        x: (width - size) / 2,
                        y: (height - size) / 2,
                      });
                    }
                  }}
                />
              </ReactCrop>
            )}
            <div className="mt-3 text-muted small">
              <FaCamera className="me-1" /> Drag the corners to select the area
              you want to keep. The image will be cropped to a perfect square.
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={cancelCrop}>
            <FaTimesCircle /> Cancel
          </Button>
          <Button variant="primary" onClick={applyCrop} className="crop-apply">
            <FaCrop /> Apply Crop
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default withAuth(ArtisanProfile, 'artisan');
